class Api {

    constructor() {
        this.currentRequest = null;
    }

    login(login_username, password, from_screen_login = false, access_token = null, lms_first_time = false, play_tab = false, start_tab = null, callback = null, retry = false, displayReactFrontLiners = true) {
        // console.log("🚀 ~ Api ~ login ~ login_username:", login_username)
        // console.log("🚀 ~ Api ~ login ~ password:", password)
        // console.log("🚀 ~ Api ~ login ~ from_screen_login:", from_screen_login)
        // console.log("🚀 ~ Api ~ login ~ access_token:", access_token)
        // console.log("🚀 ~ Api ~ login ~ lms_first_time:", lms_first_time)
        // console.log("🚀 ~ Api ~ login ~ play_tab:", play_tab)
        // console.log("🚀 ~ Api ~ login ~ start_tab:", start_tab)
        // console.log("🚀 ~ Api ~ login ~ callback:", callback)
        // console.log("🚀 ~ Api ~ login ~ retry:", retry)
        var that = this;

        var request = new Object();
        var selectedWorld = null;

        if (access_token != null || storage.getItem('access_token')) {
            if (access_token != null) {
                console.log('set access_token from login. previous access_token: ', storage.getItem('access_token'), ' new access_token: ', access_token)
                storage.setItem('access_token', access_token);
                selectedWorld = access_token;
            }
        }
        // Always use the selected world token (kc_world or world.token)
        if (!selectedWorld) {
            selectedWorld = (typeof keycloakAuth !== 'undefined' && keycloakAuth.worldToken) ? keycloakAuth.worldToken : (localStorage.getItem('kc_world') || (typeof world !== 'undefined' ? world?.token : null));
        }

        if (!selectedWorld) {
            if (typeof (world) == 'undefined') {
                return false;
            }
            selectedWorld = world?.token;
        }

        request.world_token = selectedWorld;

        request.web_user = true;
        request = JSON.stringify(request);
        $.ajax({
            type: "POST",
            url: Routing.generate('world'),
            data: request,
            beforeSend: function (jqXHR) {
                const sendAccessToken = !!storage.getItem('external_login')
                // console.log("🚀 ~ Api ~ login ~ sendAccessToken:", sendAccessToken, jqXHR)
                that.sendHeader(jqXHR, true, false, sendAccessToken)
            },
            success: function (response) {
                // console.log("🚀 ~ Api ~ login ~ response:", response)
                // El primer intento se hace con la contrasenya en sha256 si falla se reintenta con md5
                if (response.success || retry || !from_screen_login) {
                    if (that.checkisValidResult(response, !from_screen_login)) {
                        // console.log("🚀 ~ Api ~ login ~ isValidResult")
                        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_LOGIN_OK, login_username);

                        function continueLogin() {
                            // console.log("🚀 ~ Api ~ continueLogin ~ continueLogin called")

                            var passwordHash = null;

                            if (password) {
                                passwordHash = retry ? md5(password) : sha256(password);
                            }

                            that.afterLoginCallBack(response, login_username, passwordHash, from_screen_login, play_tab, start_tab, displayReactFrontLiners);
                            welcomeScreenController = new WelcomeScreenController();

                            var auxWorld = response.result.world;
                            var privacyPolicy = new Policy(auxWorld.privacy_policy_enabled, auxWorld.privacy_policy_title, auxWorld.world_brand_privacy, auxWorld.privacy_policy_checkbox);
                            var usePolicy = new Policy(auxWorld.use_policy_enabled, auxWorld.use_policy_title, auxWorld.use_policy_text, auxWorld.use_policy_checkbox);

                            // Los almaceno para usarlos luego en getUserPolicies
                            storage.setItem("privacyPolicy", JSON.stringify(privacyPolicy));
                            storage.setItem("usePolicy", JSON.stringify(usePolicy));

                            var showPrivacyPolicy = response.result.world.privacy_policy_enabled &&
                                (!response.result.user['accepted_version_privacy_policy'] ||
                                    auxWorld.last_version_privacy_policy > response.result.user['accepted_version_privacy_policy']);

                            var showUsePolicy = response.result.world.use_policy_enabled &&
                                (!response.result.user['accepted_version_use_policy'] ||
                                    auxWorld.last_version_use_policy > response.result.user['accepted_version_use_policy']);

                            if (showPrivacyPolicy && showUsePolicy) {
                                welcomeScreenController.drawPolicies(privacyPolicy, usePolicy, true, true);
                            } else if (showPrivacyPolicy) {
                                welcomeScreenController.drawPolicies(privacyPolicy, null, true, false);
                            } else if (showUsePolicy) {
                                welcomeScreenController.drawPolicies(null, usePolicy, false, true);
                            }

                            if (response.result.user.force_password_change || !response.result.user.username || response.expired_password) {
                                inIframe() ? response.result.is_lms = true : response.result.is_lms = false;
                                welcomeScreenController.draw(response.result, response.expired_password)
                            }

                            if (lms_first_time) {

                                swal({
                                        title: "",
                                        text: Translator.trans('TR_NOTIFICATION_SEND_EMAIL'),
                                        type: "input",
                                        inputType: "email",
                                        confirmButtonColor: "#DD6B55",
                                        showCancelButton: true,
                                        closeOnConfirm: false
                                    },
                                    function (inputValue) {
                                        if (inputValue === false)
                                            return false;
                                        if (inputValue === "" || !isValidEmailAddress(inputValue)) {
                                            swal.showInputError(Translator.trans('TR_IS_INVALID_EMAIL'));
                                            return false;
                                        }

                                        api.postUserInfo(auxWorld.token, null, null, null, null, true, "STOP", null, inputValue);
                                    });
                            }

                            // Bloquear el boton de play cuando no queden intentos o el juego haya sido completado en modo assesment.
                            var worldTokenRequest = new Object();
                            worldTokenRequest.world_token = auxWorld.token;
                            worldTokenRequest = JSON.stringify(worldTokenRequest);

                            if (typeof auxWorld.haveTries === "undefined") {
                                $.ajax({
                                    type: "POST",
                                    url: Routing.generate('get_game_tries'),
                                    data: worldTokenRequest,
                                    beforeSend: function (jqXHR, settings) {
                                        settings.data = that.addAccessToken(settings);
                                        that.sendHeader(jqXHR, false)
                                    },
                                    success: function (response) {
                                        if (that.checkisValidResult(response, false, false)) {
                                            var tries = response.result.tries;
                                            var game_completed = response.result.game_completed;
                                            if (auxWorld.world_mode === 'ASSESSMENT' && (tries > 1 || game_completed)) {
                                                $('#playBtn').addClass('disable-play-button');
                                                auxWorld.haveTries = false;
                                            } else {
                                                auxWorld.haveTries = true;
                                            }
                                        }
                                    }
                                });
                            } else {
                                if (auxWorld.world_mode === 'ASSESSMENT' && (!auxWorld.haveTries || user.world_completed)) {
                                    $('#playBtn').addClass('disable-play-button');
                                }
                            }

                            if (inIframe()) {

                                response.msj = 'complete';
                                window.parent.postMessage(response, '*');

                                const lmsPathId = storage.getItem("lms_path_id");

                                if (lmsPathId) {

                                    const documentationPath = documentationScreenController.documentationPath;

                                    documentationPath.setLmsPath(true);
                                    documentationPath.getPath(lmsPathId, function (pathData) {

                                        const documentId = pathData.document_root.id;
                                        const document = documentationScreenController.getDocument(documentId);
                                        const parentFolder = documentationScreenController.getParentFolder(documentId, documentationScreenController.documentation);

                                        document.pathData = pathData;
                                        documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);

                                    });

                                }

                            }

                            // Si viene con internal link, redirigir al recurso
                            callback ? callback() : null;
                        }

                        // console.log("🚀 ~ Api ~ login ~ _checkLanguageChanged")
                        that._checkLanguageChanged(response.result, continueLogin);
                    } else {
                        // console.log("🚀 ~ Api ~ login ~ NOT isValidResult")
                        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_LOGIN_FAIL, login_username);
                    }
                } else {
                    window.blackBox.setPhrase('ads', password); //md5
                    api.login(login_username, password, true, null, false, false, null, callback, true);
                }
            }
        });
    };

    login_skip_sso(login_username, password, from_screen_login = false, access_token = null, lms_first_time = false, play_tab = false, start_tab = null, callback = null, retry = false) {
        var that = this;

        var request = new Object();
        if (access_token != null || storage.getItem('access_token')) {
            if (access_token != null) {
                storage.setItem('access_token', access_token);
            }
            request.world_token = storage.getItem('access_token');
        } else {
            if (typeof (world) == 'undefined') {
                return false;
            }
            request.world_token = world?.token;
        }

        var worldToken = world?.token;

        $.ajax({
            type: "GET",
            url: Routing.generate('keycloak_info'),
            data: { 'world': worldToken },
            success: function (kcResponse) {
                if (kcResponse.client_id) {
                    kc_setClientAndWorld(kcResponse.client_id, worldToken);
                }
                that.doLoginSkipSso(request, login_username, password, from_screen_login, callback, retry);
            },
            error: function (xhr, status, error) {
                console.error('Keycloak info failed:', error);
                that.doLoginSkipSso(request, login_username, password, from_screen_login, callback, retry);
            }
        });
    };

    doLoginSkipSso(request, login_username, password, from_screen_login, callback, retry) {
        var that = this;

        request.web_user = true;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('world_skip_sso'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (response.success || retry || !from_screen_login) {
                    if (that.checkisValidResult(response, !from_screen_login)) {
                        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_LOGIN_OK, login_username);
                        kc_login(login_username, password,
                            function () {
                                callback ? callback() : null;
                            },
                            function (error) {
                                console.error('Keycloak login failed:', error);
                            }
                        );
                    } else {
                        if (typeof ga === 'function') ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_LOGIN_FAIL, login_username);
                    }
                } else {
                    window.blackBox.setPhrase('ads', password);
                    api.login_skip_sso(login_username, password, true, null, false, false, null, callback, true);
                }
            }
        });
    };

    loginWithGoogle(googleToken, worldToken) {

        var that = this;

        const data = {
            web_user: true,
            token_id: googleToken,
            world_token: worldToken,
            platform_type: "web",
        };

        $.ajax({
            type: "POST",
            url: Routing.generate('world_google_sso'),
            data: JSON.stringify(data),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    const tokenData = _.find(response.result.user.tokens, function (token) {
                        return token.world_id === response.result.world.id;
                    });

                    const loginUsername = response.result.login_username;
                    const accessToken = tokenData.access_token;

                    window.blackBox.setAvatar('ads', loginUsername );
                    storage.setItem('access_token', accessToken);
                    console.log('set access_token from loginWithGoogle. access_token: ', accessToken)
                    storage.setItem('google_access_token', accessToken);
                    // console.log("🚀 ~ Api ~ loginWithGoogle ~ google_access_token:", accessToken)

                    // Para saber si ha entrado con google y deshabilitarle los cambios de contraseña
                    storage.setItem('external_login', true);

                    // api.login(loginUsername, null, false, accessToken);
                    //////////////////////////////////////////////////

                    // If Keycloak client is configured, get OAuth token via Resource Owner Password (fallback flow)
                    
                    // console.log("🚀 ~ Api ~ loginWithGoogle ~ clientId:", clientId)

                    function continueLegacyLogin() {
                        api.login(loginUsername, null, false, accessToken);
                    }

                    if (clientId) {
                        // console.log("🚀 ~ kc_login from login with google click")
                        kc_login(loginUsername, accessToken, continueLegacyLogin);
                    } else {
                        continueLegacyLogin();
                    }
                    //////////////////////////////////////////////////////////////////////

                }

            }
        });

    };

    register(token, loginusername, username, password, name = null, external_id = null, surname = null, email = null, telephone = null, birthday = null, privacyPolicy = null, usePolicy = null, checkboxes = null, categories = null, callback = null) {
        var that = this;
        var request = new Object();

        request.world_token = token;
        request.web_user = true;
        request.user = new Object();
        request.user.birthday = birthday ? birthday : '';
        request.user.username = username;
        request.user.external_id = external_id;
        request.user.name = name ? name : '';
        request.user.last_name = surname ? surname : '';
        request.user.email = email ? email : null;
        request.user.telephone = telephone ? telephone : '';
        request.webuser = true;
        request.user.login_username = loginusername;
        request.user.password = md5(password);
        request.user.shaPassword = sha256(password);
        request.checkboxes = checkboxes;
        request.categories = categories;
        request.privacy_policy = privacyPolicy;
        request.use_policy = usePolicy;

        inIframe() ? request.user.is_lms = true : request.user.is_lms = false;

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('user_facebook_register'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                try {
                    if (!that.checkisValidResult(response)) {
                        ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_REGISTRY_FAIL, '');
                        return;
                    }

                    if (inIframe()) {
                        api.generateWorldData(response.result, true);

                        api.getCustomTranslations(false, null, 1, null, function () {
                            response.msj = 'register';
                            window.parent.postMessage(response, '*')
                        });
                    }
                    ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_REGISTRY_SUCCESS, loginusername);

                    window.blackBox.setAvatar('ads', loginusername);
                    window.blackBox.setPhrase('ads', password);

                    inIframe() ? response.result.is_lms = true : response.result.is_lms = false;

                    world.update(response.result.world);

                    $("#register-modal").modal("hide");

                    api.login($('#loginEmail').val(), $('#loginPassword').val(), true, null, false, false, null, callback);
                } catch (e) {
                    console.trace('error user_facebook_register: ', e, request);

                    if (window.Sentry) {
                        Sentry.captureException(e);
                    }
                }
            },
            error: function (e) {
                console.trace("user_facebook_register", e);

                if (window.Sentry && e && e.status >= 500) {
                    Sentry.captureMessage('API error: user_facebook_register', {
                        level: 'error',
                        fingerprint: ['api-error', 'user_facebook_register', String(e.status)],
                        extra: {status: e.status, statusText: e.statusText},
                    });
                }
            }
        });
    };

    newAchievment(token, achievementId) {

        var that = this;
        var request = new Object();
        request.world_token = token;
        request.achievement_id = achievementId;

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('user_achievement'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    var result = response.result;
                    var template = Handlebars.compile($("#worldNewAchievementNotification").html());
                    $("#modalChallenge").html(template(result)).modal('show');
                }
            }
        });
    };

    levelChange(token, levelId, onSuccess) {

        var that = this;
        var request = new Object();
        request.world_token = token;
        request.level_id = levelId;

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('user_level'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    onSuccess(response);
                }
            }
        });
    };

    loginNotifications(token, fecha, offset, limit) {

        var that = this;

        var request = {};
        request.world_token = token;
        request.min_date = fecha;
        request.offset = 0;
        request.limit = 25;

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('user_notifications'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    var result = response.result;

                    $.each(result.notifications, function (index, notification) {
                        notificationSystem.notificationArray.push(notification.notification);
                    });

                    if (notificationSystem) {
                        notificationSystem.checkForNotifications();
                    }
                }
            }
        });
    };

    afterLoginCallBack(response, login_username, password, from_screen_login, play_tab = false, start_tab = null, displayReactFrontLiners = true) {
        var template;
        var tabs = new Tabs();
        var result = response.result;
        var showHelpModal = response.result.world.shows_help;
        var that = this;
        user = new User(result.user);

        documentationScreenController.categoriesStack = [];

        var cT = Math.floor(Date.now() / 1000);
        var shouldIncreaseLoginNumber = storage.getItem("last_visit") === null
            || (cT - storage.getItem("last_visit")) > 3600
            || from_screen_login;

        if (storage.getItem("last_visit") === null) {
            storage.setItem('last_visit', cT);
        } else {
            storage.setItem('last_visit', Math.floor(Date.now() / 1000));
        }

        baseController.resetStackableOrder();

        result.world.theme = result.theme;
        storage.setItem("world", encodeURIComponent(JSON.stringify(result.world)));

        if (login_username) {
            window.blackBox.setAvatar('ads', login_username);
        }
        if (password) {
            window.blackBox.setPhrase('ads', password);
        }

        //Añadmios la dimension de user
        if (typeof ga === 'function') ga('set', 'dimension' + analytics.GA_DIMENSION_USER, user.user_world_id);

        result.world.game_bets.sort(dynamicSort('-order', 'game_bet'));

        if (typeof world.update === 'undefined') {
            world = new World(result.world)
        }
        world.update(result.world);

        $.each(result.user.tokens, function (index, value) {
            if (value.token == world.token) {
                world.access_token = value.access_token;
                if (!storage.getItem('external_login')) {
                    storage.setItem('access_token', value.access_token);
                }
            }
        });

        if (typeof (notificationSystem) != 'object') {
            notificationSystem = new NotificationSystem(result.user_last_notification_viewed);
        }

        if (shouldIncreaseLoginNumber) {
            this.increaseLoginNumber();
        }

        //pintar base
        template = Handlebars.compile($("#baseScreen").html());
        world.is_lms = inIframe();

        //================= REACT ZUSTAND BRIDGE =================
        // Send world and user to react

        // console.log('rendering... sending world and user to react...');

        /**
         * check if project is module app
         * check if user needs to change password (don't show react app)
         */
        const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';
        const userNeedChanges = result?.user?.force_password_change || !result?.user?.username;
        const expiredPassword = response?.expired_password ?? false;

        if (isModuleApp && !userNeedChanges && !expiredPassword) {
            if (displayReactFrontLiners) {
                document.querySelector('#reactFrontLiners').style.display = 'block';
                const loginDiv = document.querySelector('#reactLogin');
                if (loginDiv) loginDiv.style.display = 'none';
            }
            document.querySelector('#mainContainer').style.display = 'none';

            setTimeout(() => {
                $('#modalLoading').modal('hide');
            }, 1000);

            const {title, folder_id, ...rest} = world?.app_pages[0] ?? {};

            window.reactZustandBridge.setUser(result.user);
            window.reactZustandBridge.setWorld(world);
            
            if (result.url_chatbot)
                window.reactZustandBridge.setChatbot(result.url_chatbot);

            //load socket ids
            if (!docSocket) {
                docSocket = api.quizSoquet();
            }

            let template = Handlebars.compile($("#floatButtonsFragment").html());
            $("#reactFloatButtons").html(template({
                world,
                newDocumentTypes: documentationScreenController.documentationNew.getDocumentTypes(),
            }));

            const alertNode = document.createElement('div');
            alertNode.innerHTML = `
                 <div class="bf-alert">
                    <div class="body">
                        <img class="icon" src="" alt="icon">
                        <p class="title"></p>
                        <div class="content"></div>
                    </div>
                </div>
            `;

            document.body.appendChild(alertNode);
        } else {
            // checking if maincontainer is necessary

            // console.log('rendering mainContainer...');
            $("#mainContainer").html(template(world));
        }

        //================= END REACT ZUSTAND BRIDGE =================


        if (world.is_lms && storage.getItem("lms_path_id")) {
            $("#appHeader").removeClass("world_color_1_bg");
        }

        baseController.draw(world.theme);

        // Comprobar que sea visible para poder abrirla en el nuevo mundo
        let selected_tab = _.filter(result.world.world_tabs, function (tab) {
            return tab.world_tab_id == start_tab && tab.visible
        });

        if (play_tab) {
            this.loadPlayTab(worldHomeController, template, baseController);
        } else {
            if (selected_tab.length > 0) {
                baseController.selectedTabAction(start_tab, selected_tab[0].folder_tab_id);
            } else {
                this.loadFirstTab(worldHomeController, template, baseController, world.world_tabs);
            }
        }

        worldHomeController.draw(world.theme, user, showHelpModal);

        notificationSystem.canShowNotifications = true;
        notificationSystem.checkForNotifications();

        //hemos de hacer otra llamada para recuperar los  retos pendientes
        this.getPendingChallenges(world.token, false);

        if (baseController.selectedTabId !== tabs.CHAT_TAB) {
            // Obtener el numero de mensajes no leidos
            api.getChats(function (roomsResponse) {
                that.getUnreadMessages(roomsResponse.rooms);
                chatScreenController.drawChatUnreadMessages();
                chatScreenController.saveRooms(roomsResponse.rooms, true);
            });
        }

        const notificationsOffset = 0;
        const notificationsLimit = 1;

        // Pedir las notificaciones para saber si hay que mostrar el icono con la alerta o no
        // Solo hace falta pedir una para comprobar si hay notificaciones pendientes o no
        api.getNotifications(notificationsOffset, notificationsLimit, null, function (response) {
            if (api.checkisValidResult(response)) {
                if (response.result.total_unread) {

                    if(window.reactZustandBridge) {
                        // Connected with User Store, change if has notifications
                        window.reactZustandBridge.changeNotificationState(true);
                    }
                    
                    $("#open-notifications-button > .has-notifications").show();
                    $("#open-notifications-button > .has-not-notifications").hide();
                }
            }
        }, false);

        // IMPORTANTE: Aunque haya un connect y un quizSoquet ambos acaban apuntando a la funcion getSocket de notificationSystem
        // por lo que solo hay 1 conexion abierta. Esta puesto asi para que el chat ya pueda utilizar la v2 de los sockets pero lo otro siga con el antiguo.
        // una vez  este en orden las otras partes el this.quizSoquet desaparecera y solo quedara el connect que sera quien haga la conexion
        // Conexion del socket una vez se ha logueado correctamente
        socketRequest.connect();
        // Suscripcion a los eventos de socket (Cuando se envie un mensaje nuevo y cuando el receptor vea los mensajes)
        socketResponse.sendMessage();
        socketResponse.notifyUpdatedRoom();

        this.quizSoquet();

        // Una vez conectado, al volver a loguearnos con exito en otro mundos se cerrara la conexion y se revolvera a reconectar con el nuevo user_world_id
        if (notificationSystem.socket.connected) {
            notificationSystem.socket.close();
        }

    };

    quizSoquet() {
        return notificationSystem.getSocket();
    }

    getHistoryChallenges(token) {
        var that = this;
        var request = new Object();
        request.world_token = token;
        request.limit = 100;
        request.offset = 0;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            data: request,
            url: Routing.generate('challenges_history'),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    var template;
                    var result = response.result;

                    challengeListScreenController.historyChallenges = result;

                    for (let index in result.games)
                        result.games[index].game.points = result.games[index].game.points.toLocaleString("es-ES");

                    template = Handlebars.compile($("#worldChallengeHistoryScreen").html());
                    var context = {challenges: result, user: user, starIcon: customIcons["BET_ICON"]};
                    $("#challengeHistoryDiv").html(template(context));
                    that.tintStars();
                }
            }
        });
    };

    tintStars() {
        $('.star').each(function (index, element) {
            tintImage($(element).attr('id'), customIcons["BET_ICON"], world.theme.color_1);
            tintImage($(element).attr('id'), customIcons["BET_ICON"], world.theme.color_1);
            tintImage($(element).attr('id'), customIcons["BET_ICON"], world.theme.color_1);
        });
    }

    getChallengeInfo(token, game_id, action, closeAction, showLoader = false) {

        var that = this;

        var request = {};
        request.world_token = token;
        request.game_id = game_id;

        request = JSON.stringify(request);

        $('#modalChallenge').modal('hide');

        $.ajax({
            type: "POST",
            data: request,
            url: Routing.generate('duel_information'),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showLoader)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    var result = response.result;
                    result.world = world;
                    var template;

                    worldHomeController.challenge = result;

                    if (closeAction) {
                        result.action = closeAction;
                    }

                    if (action == 'CHALLENGE_FINISHED' || action == 'NEW_CHALLENGE') {

                        if (action == 'CHALLENGE_FINISHED')
                            template = Handlebars.compile($("#worldChallengeResumeModal").html());

                        if (action == 'NEW_CHALLENGE')
                            template = Handlebars.compile($("#newChallengeModal").html());

                        result.game.points = result.game.points.toLocaleString("es-ES");
                        result.starIcon = customIcons["BET_ICON"];

                        result.challengeNotification = true;

                        that.getChartToken(function (responseToken) {
                            result.token = responseToken.token;
                            $("#modalContainer").html(template(result)).modal('show');
                        });

                        $(document).one('click', '.modal-close-btn, .modal-accept-btn', function () {
                            $("#modalContainer").modal('hide').empty();
                            $(document).off('click', '.modal-close-btn, .modal-accept-btn');
                        });
                    }

                    if (action == 'ACCEPT_CHALLENGE') {

                        var category_id = worldHomeController.challenge.game.category.id;
                        var challenge_user_id = worldHomeController.challenge.game.opponent.user_world_id;
                        var bet_stars = worldHomeController.challenge.game.stars;
                        worldHomeController.setChallengeRequest(world.token, category_id, challenge_user_id, bet_stars);
                        worldHomeController.createChallenge(worldHomeController.challenge.game.opponent, 'CONFIRM_CHALLENGE', game_id, false);
                    }

                    if (action == 'REVENGE_CHALLENGE') {

                        var category_id = worldHomeController.challenge.game.category.id;
                        var challenge_user_id = worldHomeController.challenge.game.opponent.user_world_id;
                        var bet_stars = worldHomeController.challenge.game.stars;
                        worldHomeController.setChallengeRequest(world.token, category_id, challenge_user_id, bet_stars);
                        worldHomeController.createChallenge(worldHomeController.challenge.game.opponent, 'REVENGE_CHALLENGE', game_id, true);
                    }
                    return false;
                }
            }
        });
    };

    getPendingChallenges(token, showLoader = true, isChat = false, onSuccessFunction) {

        var that = this;
        $.ajax({
            type: "POST",
            url: Routing.generate('pending_challenges', {world_token: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showLoader)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    if (onSuccessFunction) {
                        onSuccessFunction(response);
                    } else {
                        var result = response.result;
                        var pendingChallengesCount = 0;

                        challengeListScreenController.pendingChallenges = result;

                        if (showLoader) {
                            var template = Handlebars.compile($("#worldChallengeScreen").html());
                            var context = {challenges: result, user: user, "starIcon": customIcons["BET_ICON"]};
                            let tabs = new Tabs();
                            let tab = baseController.getTabById(tabs.RETOS_TAB);
                            baseController.stackView(tab, template, context);

                            if (isChat) {
                                $("#chat-messages-challenge-area").html(template(context));
                            }

                            that.getHistoryChallenges(token);
                            that.tintStars();
                        }

                        $.each(result.challenges, function (index, challenge) {
                            if (challenge.game.user_world_creator_id != user.user_world_id) {
                                pendingChallengesCount++;
                            }
                        });

                        if (pendingChallengesCount > 0) {
                            $('#baseBadgeChallengesTxt').text(pendingChallengesCount);
                        }
                    }

                }
            }
        });
    };

    getIndividualRanking(request, success) {
        const that = this;
        $.ajax({
            type: "POST",
            url: Routing.generate('detailed_ranking'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            }, success
        });
    }

    getGroupRanking(request, success) {
        const that = this;
        $.ajax({
            type: "POST",
            url: Routing.generate('group_detailed_ranking'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            }, success
        });
    }

    getSegments(callbackFunc) {
        let token = world.token;
        let that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('world_categories_list', {worldToken: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    callbackFunc(response);
                }
            }
        });
    }

    getSubsegments(catId, search, callbackFunc) {
        let token = world.token;
        let that = this;
        let request = {};

        if (search.length > 0) {
            request.search = search
        }

        $.ajax({
            type: "GET",
            url: Routing.generate('world_category_items_list', {worldToken: token, worldCategoryId: catId}),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    callbackFunc(response);
                }
            }
        });
    }

    getUsers(search, segmentId, callbackFunc) {
        let that = this;
        let request = {};

        request.world_token = world?.token;
        request.limit = 10;
        request.offset = 0;
        search ? request.friend_username = search : null;
        segmentId ? request.sub_category_id = segmentId : null;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('get_user_friends'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    callbackFunc(response.result.friends);
                }
            }
        });
    }

    getGeneralRanking(token) {

        //Si showLoader es false, solo lo queremos para contar los retos pendientes.
        var that = this;

        // Custom icons
        var rankingIcon = customIcons["RANKING_TOP_BEST"];
        var challengeIcon = customIcons["RANKING_TOP_CHALLENGE"];
        var wiseIcon = customIcons["RANKING_TOP_WISE"];
        var fastIcon = customIcons["RANKING_TOP_FASTEST"];
        var accuracyIcon = customIcons["RANKING_TOP_ACCURACY"];

        $.ajax({
            type: "POST",
            url: Routing.generate('general_ranking', {world_token: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    var result = response.result;
                    var tabs = new Tabs();
                    var tab = baseController.getTabById(tabs.RANKING_TAB);
                    var template = Handlebars.compile($("#worldGeneralRankingScreen").html());
                    var translatorRankingValue;
                    var formatterUnits = 1;
                    var units = '';

                    switch (result.rankings[0].ranking.ranking_id) {

                        case rankingScreenController.ranking.RANKING_TOP_BEST_CATEGORY:
                            translatorRankingValue = Translator.trans('TR_X_PUNTOS_AND');
                            break;
                        case rankingScreenController.ranking.RANKING_TOP_CHALLENGE_CATEGORY:
                            translatorRankingValue = Translator.trans('TR_X_RETOS_AND');
                            break;
                        case rankingScreenController.ranking.RANKING_TOP_WISE_CATEGORY:
                            translatorRankingValue = Translator.trans('TR_X_PREGUNTAS_AND');
                            break;
                        case rankingScreenController.ranking.RANKING_TOP_FASTEST_CATEGORY:
                            translatorRankingValue = Translator.trans('TR_X_SEGUNDOS_AND');
                            formatterUnits = 1000;
                            break;
                        case rankingScreenController.ranking.RANKING_TOP_ACCURACY_CATEGORY:
                            translatorRankingValue = Translator.trans('TR_X_RATIO_AND');
                            units = ' %';
                            break;

                    }

                    //Añadimos la info de los rankings al objeto world
                    world.rankings = result;

                    if (world.play_in_groups && world.group_rank_category_id) {
                        let detailRequest = new Object();

                        detailRequest.world_token = token;
                        //Los 3 mejores
                        detailRequest.ranking_id = 1;
                        detailRequest.ranking_category_id = world.group_rank_category_id;
                        detailRequest.offset = 0;
                        detailRequest.limit = 3;
                        detailRequest = JSON.stringify(detailRequest);

                        $.ajax({
                            type: "POST",
                            url: Routing.generate('detailed_ranking'),
                            data: detailRequest,
                            beforeSend: function (jqXHR, settings) {
                                settings.data = that.addAccessToken(settings);
                                that.sendHeader(jqXHR, true)
                            },
                            success: function (detailResponse) {
                                if (that.checkisValidResult(detailResponse)) {
                                    let topGroups = detailResponse.result;

                                    for (var i = 0; i < topGroups.top.length; i++) {
                                        topGroups.top[i].group.sortName = topGroups.top[i].group.name.substr(0, 2);
                                    }

                                    _.forEach(topGroups.top, function (ranking) {
                                        ranking.group.customUnit = sprintf(translatorRankingValue, (ranking.group.points / formatterUnits)) + units;
                                    });

                                    var context = {
                                        rankings: result,
                                        world: world,
                                        topGroups: topGroups.top,
                                        rankingIcon: rankingIcon,
                                        challengeIcon: challengeIcon,
                                        wiseIcon: wiseIcon,
                                        fastIcon: fastIcon,
                                        accuracyIcon: accuracyIcon
                                    };

                                    baseController.stackView(tab, template, context);
                                    rankingScreenController.draw();
                                    that.getPendingChallenges(world.token, false);
                                }
                            }
                        });
                    } else {
                        _.map(result.rankings[0].ranking.top, function (user) {
                            user.user.customUnit = sprintf(Translator.trans('TR_X_PUNTOS_AND'), user.user.points);
                        });

                        const isModuleApp = window.reactZustandBridge && world?.mode === 'newLayout';

                        var context = {
                            rankings: result,
                            world: world,
                            rankingIcon: rankingIcon,
                            challengeIcon: challengeIcon,
                            wiseIcon: wiseIcon,
                            fastIcon: fastIcon,
                            accuracyIcon: accuracyIcon,
                            addToStack: isModuleApp
                        };

                        baseController.stackView(tab, template, context);
                        rankingScreenController.draw();
                        that.getPendingChallenges(world.token, false);
                    }
                }
            },
            complete: function () {
                if(window.runCallback) {
                    window.runCallback();

                    setTimeout(() => {
                        window.runCallback = null;
                    }, 300);
                }
            }
        });
    };

    getDocumentGameRanking(documentId, limit, onSuccess) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('game_document_own_ranking', {worldHelpLinkId: documentId, limit: limit}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: onSuccess
        });
    }

    createNewChallenge(request, opponent) {
        var that = this;

        //Si es aleatoria, tenemos que eliminar el category. Antes era necesario para sacar los colores del splah
        if (request.category_id == 0) {
            delete request.category_id;
        }

        request = JSON.stringify(request);
        $.ajax({
            type: "POST",
            url: Routing.generate('new_duel_game'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                if (that.checkisValidResultChallenge(response)) {
                    var template;
                    var result = response.result;

                    if (result.game.num_questions == 0) {

                        swal({
                                title: "",
                                text: Translator.trans('TR_NO_EXISTEN_SUFICIENTES_PREGUNTAS_DE_ESTA_CATEGORIA'),
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "",
                                closeOnConfirm: true
                            },
                            function () {
                                $("#modalChallenge").modal('hide');
                                api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                            });
                    } else {

                        playScreenController = new PlayScreenController(result, true);

                        var context = {user: user, opponent: opponent, result: result};

                        template = Handlebars.compile($("#worldChallengePlayScreen").html());
                        $("#mainContainer").html(template(context));

                        var bottomContext = result.wildcards;
                        bottomContext['resolveIcon'] = customIcons["RESOLVE"];
                        bottomContext['simplifyIcon'] = customIcons["SIMPLIFY"];
                        bottomContext['extraTimeIcon'] = customIcons["EXTRA_TIME"];

                        template = Handlebars.compile($("#worldPlayBottomScreen").html());
                        $("#playBottom").html(template(bottomContext));
                        $("#playBottom").show();
                        playScreenController.draw(result);
                    }
                }
            }
        });
    };

    cloneChallenge(token, game_id) {
        var that = this;
        var request = new Object();
        var template;

        request.world_token = token;
        request.game_id = game_id;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('clone_duel'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {

                if (that.checkisValidResult(response, false, false)) {

                    if (response.result.game.questions.length == 0) {
                        swal({
                            title: "",
                            text: Translator.trans('TR_NO_EXISTEN_SUFICIENTES_PREGUNTAS_DE_ESTA_CATEGORIA'),
                            type: 'warning',
                            confirmButtonText: ''
                        });
                        return false;
                    }

                    var template;
                    var result = response.result;
                    var challengeOpponent = new Object();
                    var context = {user: user, opponent: worldHomeController.challenge.game.opponent, result: result};

                    playScreenController = new PlayScreenController(result, true);

                    template = Handlebars.compile($("#worldChallengePlayScreen").html());
                    $("#mainContainer").html(template(context));

                    template = Handlebars.compile($("#worldPlayBottomScreen").html());

                    var bottomContext = result.wildcards;
                    bottomContext['resolveIcon'] = customIcons["RESOLVE"];
                    bottomContext['simplifyIcon'] = customIcons["SIMPLIFY"];
                    bottomContext['extraTimeIcon'] = customIcons["EXTRA_TIME"];

                    $("#playBottom").html(template(bottomContext));
                    playScreenController.draw(result);
                }
            }
        });
    };

    confirmChallenge(token, game_id) {
        var that = this;
        var request = new Object();
        request.world_token = token;
        request.game_id = game_id;
        request = JSON.stringify(request);
        $.ajax({
            type: "POST",
            url: Routing.generate('new_duel_game'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    var template;
                    var result = response.result;
                    var challengeOpponent = new Object();
                    playScreenController = new PlayScreenController(result, true);

                    var context = {user: user, opponent: worldHomeController.challenge.game.opponent, result: result};

                    template = Handlebars.compile($("#worldChallengePlayScreen").html());
                    $("#mainContainer").html(template(context));

                    template = Handlebars.compile($("#worldPlayBottomScreen").html());

                    var bottomContext = result.wildcards;
                    bottomContext['resolveIcon'] = customIcons["RESOLVE"];
                    bottomContext['simplifyIcon'] = customIcons["SIMPLIFY"];
                    bottomContext['extraTimeIcon'] = customIcons["EXTRA_TIME"];
                    $("#playBottom").html(template(bottomContext));

                    playScreenController.draw(result);
                }
            }
        });
    };

    createNewGame(world_token, category_id, categoryData = null) {

        var that = this;
        var template;
        var request = new Object();
        var context;
        var c = sha256(String(world.id) + "#" + String(user.user_world_id)).substring(0, 32);
        var iv = "54642s1165442121";
        var xs = gxs(16);

        request.world_token = world_token;

        if (category_id != 0) {
            request.category_id = category_id;
        }
        request = JSON.stringify(request);

        if (categoryData) {
            context = {name: categoryData.name, icon: categoryData.icon, color: categoryData.color};
        } else {
            if (category_id == 0) {
                context = {
                    name: Translator.trans('TR_ALEATORIA'),
                    icon: world.theme.random_category_icon,
                    color: world.theme.base_color,
                    world_assessment: world.world_mode === 'ASSESSMENT'
                };
            } else {
                $.each(world.categories, function (index, value) {
                    if (value.category.id == category_id) {
                        context = {
                            name: value.category.name,
                            icon: value.category.icon,
                            color: value.category.color
                        };
                    }
                });
            }
        }

        $("#baseMenuDiv").hide();
        template = Handlebars.compile($("#worldLoadingQuestionsScreen").html());
        $("#jugar").html(template(context));

        loadingQuestionsScreenController.draw(context);

        let ajaxStartGame = function () {
            $.ajax({
                type: "POST",
                url: Routing.generate('new_game'),
                data: request,
                beforeSend: function (jqXHR, settings) {
                    settings.data = that.addAccessToken(settings);
                    that.sendHeader(jqXHR, false, xs);
                },
                success: function (response) {

                    if (typeof response !== 'object') {

                        var de = response;
                        var dk = CryptoJS.enc.Utf8.parse(c);
                        var dv = CryptoJS.enc.Utf8.parse(iv);
                        var d = CryptoJS.AES.decrypt(de, dk, {iv: dv});

                        d = CryptoJS.enc.Utf8.stringify(d);
                        response = JSON.parse(d);

                    }

                    if (that.checkisValidResult(response)) {
                        var template;
                        var result = response.result;

                        if (world.world_mode === 'ASSESSMENT') {
                            var warningMessage = Translator.trans('TR_HAS_ALCANZADO_EL_MAXIMO_NUMERO_DE_INTENTOS');
                        } else {
                            var warningMessage = Translator.trans('TR_NO_EXISTEN_SUFICIENTES_PREGUNTAS_DE_ESTA_CATEGORIA');
                        }

                        if (parseInt(result.game.num_questions) === 0) {
                            swal({
                                    title: "",
                                    text: warningMessage,
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "",
                                    closeOnConfirm: true
                                },
                                function () {
                                    $("#modalChallenge").modal('hide');
                                    api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                                });
                        } else {
                            result.is_assessment = world.world_mode === 'ASSESSMENT';
                            result.is_challenge = false;
                            result.has_test = false;
                            result.is_path_assessment = false;
                            playScreenController = new PlayScreenController(result, false);
                            template = Handlebars.compile($("#worldPlayScreen").html());
                            $("#mainContainer").html(template(result));

                            context = result.wildcards;
                            context['resolveIcon'] = customIcons["RESOLVE"];
                            context['simplifyIcon'] = customIcons["SIMPLIFY"];
                            context['extraTimeIcon'] = customIcons["EXTRA_TIME"];

                            template = Handlebars.compile($("#worldPlayBottomScreen").html());
                            $("#playBottom").html(template(context));
                            $("#playBottom").show();
                            playScreenController.draw(result);
                        }
                    }
                }
            });
        };

        var increaseRequest = new Object();
        increaseRequest.world_token = world_token;
        increaseRequest = JSON.stringify(increaseRequest);

        $.ajax({
            type: "POST",
            url: Routing.generate('get_game_tries'),
            data: increaseRequest,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                if (response['success']) {
                    var tries = response.result.tries;
                    var game_completed = response.result.game_completed;

                    if (world.world_mode === 'ASSESSMENT' && tries <= 1 && !game_completed) {
                        var template = Handlebars.compile($("#gameAssessmentTriesModal").html());
                        var context = {
                            "tries": tries,
                            "estimatedDuration": world['estimated_game_duration'],
                            "assessmentIco": customIcons["ASSESSMENT_ICON"]
                        };

                        $("#modalContainer").html(template(context)).modal('show');

                        $("#game-assessment-tries-modal .modal-close-btn").click(function (e) {
                            e.preventDefault();

                            $("#modalChallenge").modal('hide');
                            api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                        });

                        $("#game-assessment-tries-accept-btn").click(function () {
                            ajaxStartGame();
                            $("#modalContainer").modal('hide').empty();
                        });
                    } else if (world.world_mode === 'ASSESSMENT' && tries > 1 && !game_completed) {
                        swal({
                                title: "",
                                text: Translator.trans('TR_HAS_ALCANZADO_EL_MAXIMO_NUMERO_DE_INTENTOS'),
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "",
                                closeOnConfirm: true
                            },
                            function () {
                                $("#modalChallenge").modal('hide');
                                api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                            });
                    } else if (game_completed) {
                        let warningMessage = Translator.trans('TR_NO_EXISTEN_SUFICIENTES_PREGUNTAS_DE_ESTA_CATEGORIA');

                        swal({
                                title: "",
                                text: warningMessage,
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "",
                                closeOnConfirm: true
                            },
                            function () {
                                $("#modalChallenge").modal('hide');
                                api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                            });
                    } else {
                        ajaxStartGame();
                    }
                }
            }
        });
    };

    // Crear Juego de un documento tipo JUEGO/TEST/POLL o JUEGO/TEST del Path
    createNewDocumentGame(documentId) {
        const that = this;

        //open loading view
        $('#modalLoading').modal('show');

        const uri = Routing.generate('game_document_own_new_game', {worldHelpLinkId: documentId});

        $.ajax({
            type: "GET",
            url: `${uri}?encrypt=true`,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                if(response.encrypt) {
                    response = that.helperDecryptResponse(response);
                }

                if (that.checkisValidResult(response)) {

                    let template = null;
                    const result = response.result;
                    const context = result.wildcards;

                    result.is_doc_type_game_or_test = documentObj.own_game != undefined || documentObj.own_test !== undefined;
                    result.has_test = documentObj.own_test !== undefined;
                    result.own_test = documentObj.own_test;
                    result.own_game = documentObj.own_game;
                    result.own_poll = documentObj.own_poll;
                    result.is_assessment = world.world_mode === 'ASSESSMENT';
                    result.is_challenge = false;

                    if (documentObj.is_path_content) {
                        if (documentObj.own_game) {
                            result.is_path_assessment = documentObj.own_game.is_path_assessment_game;
                        }

                        if (documentObj.own_test) {
                            result.is_path_assessment = documentObj.own_test.is_path_assessment_test;
                        }
                    }

                    playScreenController = new PlayScreenController(result, false);

                    if (documentObj.is_path_content) {
                        documentationScreenController.documentationProgress.stopRead(documentObj.path_document_id);
                    }

                    // Si es una encuesta
                    if (result.own_poll != undefined) {
                        template = Handlebars.compile($("#worldPollScreen").html());
                        $("#mainContainer").html(template({
                            pollName: documentObj.name,
                            pollColor: documentObj.own_poll.color,
                            pollDarkColor: documentObj.own_poll.dark_color
                        }));

                        $('.play-top.poll .title').dotdotdot({
                            wrap: 'word',
                            watch: true,
                            height: 40
                        });

                        playScreenController.drawPoll(result);

                        // IZE-9531 (bug encontrado en pruebas manuales, 2026-09-10): la encuesta no debe
                        // seguir el ciclo genérico de tracking (start/update/stop) — completa por su
                        // propio ciclo new-game/register, igual que Juego y Test (ver TC-POLL-01).
                        // Antes se llamaba aquí a startRead/stopRead incondicionalmente al abrir/cerrar.

                        $('#documentation-header-close-btn').one('click.closePoll', function () {

                            // IZE-9629 (FR-025, TASK-012): cerrar la encuesta antes de responder
                            // todas las preguntas es un cierre anticipado — dispara tracking/stop
                            // con el tiempo desde la última pregunta respondida (o desde new-game).
                            playScreenController.handleClosedBeforeFinishing();

                            let template = Handlebars.compile($("#baseScreen").html());
                            $("#mainContainer").html(template(world));
                            baseController.draw(world.theme);

                            if (baseController.currentActiveTab.id === new Tabs().LINKS_TAB) {
                                // FIX Al cerrar el cuestionario las petañas de la web y el contenido no se engancha al html.
                                setTimeout(function () {
                                    documentationScreenController.openDocumentation(documentationScreenController.documentation, null, null, false);
                                }, 1);
                            } else {
                                baseController.selectedTabAction(baseController.currentActiveTab.world_tab_id);
                            }

                        });
                        // Si es un test / juego
                    } else {
                        template = Handlebars.compile($("#worldPlayScreen").html());
                        $("#mainContainer").html(template(result));
                        template = Handlebars.compile($("#worldPlayBottomScreen").html());

                        context['resolveIcon'] = customIcons["RESOLVE"];
                        context['simplifyIcon'] = customIcons["SIMPLIFY"];
                        context['extraTimeIcon'] = customIcons["EXTRA_TIME"];

                        $("#playBottom").html(template(context));
                        $("#playBottom").show();

                        playScreenController.draw(result);

                        // IZE-9531 (bug encontrado en pruebas manuales, 2026-09-10): el juego no debe
                        // seguir el ciclo genérico de tracking (start/update/stop) — completa por su
                        // propio ciclo new-game/register (ver TC-GAME-01). Antes se llamaba aquí a
                        // startRead incondicionalmente al empezar a jugar.

                    }

                    // Si es juego - test - encuesta y no es del path enviar el estado en progreso al empezar el juego
                    if (!documentObj.is_path_content) {
                        const documentationProgress = documentationScreenController.documentationProgress;
                        documentationProgress.setInProgress(documentObj.id);
                    }

                }
            },
            complete: function () {
                //close loading view
                $('#modalLoading').modal('hide');
            }
        });
    }

    /**
     * Helper to decrypt API response.
     * @param response
     * @returns {any}
     */
    helperDecryptResponse(response) {
        const encrypted = response.encrypt;
        const key = CryptoJS.enc.Utf8.parse("wiki123456quiz12");
        const decrypted = CryptoJS.AES.decrypt(
            encrypted,
            key,
            { mode: CryptoJS.mode.ECB }
        );

        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

        return JSON.parse(decryptedText);
    }

    createNewDocumentationTest(world_token, document_id) {
        let that = this;

        let request = {
            document_id: document_id,
            world_token: world_token,
            encrypt: true
        };

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('documentation_new_game'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                if(response.encrypt) {
                    response = that.helperDecryptResponse(response);
                }

                if (that.checkisValidResult(response)) {
                    var template;
                    var result = response.result;
                    $("#modalContainer").modal('hide');
                    if (result.game.num_questions == 0) {
                        swal({
                                title: "",
                                text: Translator.trans('TR_NO_EXISTEN_SUFICIENTES_PREGUNTAS_DE_ESTE_DOCUMENTO'),
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "",
                                closeOnConfirm: true
                            },
                            function () {

                            });
                    } else {
                        let advancedView = storage.getItem("documentation-advanced-mode") === 'true';
                        let lastReadingItem = documentationScreenController.documentationScroll.currentReadingDocument;
                        let lastDocument = null;
                        let currentFolder = documentationScreenController.getCurrentFolder();

                        if (lastReadingItem)
                            lastDocument = currentFolder['documents'][documentationScreenController.getDocumentIndex(lastReadingItem)];

                        function drawTestScreen() {
                            result.is_doc_game_or_test = true;
                            result.has_test = documentObj.has_test;
                            result.is_assessment = world.world_mode === 'ASSESSMENT';
                            result.is_challenge = false;
                            result.is_path_assessment = false;
                            playScreenController = new PlayScreenController(result, false);
                            template = Handlebars.compile($("#worldPlayScreen").html());
                            $("#mainContainer").html(template(result));
                            template = Handlebars.compile($("#worldPlayBottomScreen").html());

                            var context = result.wildcards;
                            context['resolveIcon'] = customIcons["RESOLVE"];
                            context['simplifyIcon'] = customIcons["SIMPLIFY"];
                            context['extraTimeIcon'] = customIcons["EXTRA_TIME"];

                            $("#playBottom").html(template(context));
                            $("#playBottom").show();

                            playScreenController.draw(result);
                        }

                        if (advancedView && lastDocument && lastDocument.type === 'IMAGE') {
                            drawTestScreen();
                            documentationScreenController.documentationScroll.stopCurrentReadingItem(null, $('.documentation-advanced-documents-row[data-folder="' + currentFolder.id + '"]').first());
                        } else {
                            drawTestScreen();
                        }
                    }
                }
            }
        });
    };

    getFriends(world_token, isChallenge, inputvalue, sectionId = null) {
        let that = this;
        let request = {};
        request.world_token = world_token;
        request.limit = 10;
        request.offset = 0;

        if (inputvalue) {
            request.friend_username = inputvalue;
        }

        if (sectionId) {
            request.sub_category_id = sectionId;
        }

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('get_user_friends'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    let result = response.result;
                    let users = [];
                    result.inputValue = inputvalue;

                    // Eliminar el user intermedio
                    result.friends.forEach(function (item) {
                        users.push(item.friend);
                    });
                    worldHomeController.friends = users;

                    let tabs = new Tabs();
                    let tab = baseController.getTabById(tabs.AMIGOS_TAB);

                    if (isChallenge || !tab?.visible) {
                        friendsScreenController.draw(result, isChallenge, true, !tab || isChallenge ? false : tab.name);
                    } else {
                        friendsScreenController.draw(result, isChallenge);
                    }

                    that.getPendingChallenges(world.token, false);

                    ga('send', 'pageview', analytics.GA_SCREEN_FRIENDS);
                }
            }
        });
    };

    sendCompleteGame(request) {
        var that = this;
        var request_data = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('complete_game'),
            data: request_data,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    if (inIframe()) {
                        response.msj = 'complete';
                        window.parent.postMessage(response, '*');
                    }
                    // Contamos el número de preguntas totales, correctas e incorrectas, y sumamos los puntos.
                    var correctAnswers = 0, incorrectAnswers = 0, points = 0, mAnswers = 0, bAnswers = 0, pAnswers = 0,
                        nAnswers = 0;
                    var totalAnswers = request.game.questions.length;

                    $.each(request.game.questions, function (i, obj) {
                        if (world.world_mode === 'ASSESSMENT') {
                            switch (obj.answer_type) {
                                case CORRECTANSWER:
                                    mAnswers++;
                                    correctAnswers++;
                                    break;
                                case ANSWER2:
                                    bAnswers++;
                                    incorrectAnswers++;
                                    break;
                                case ANSWER3:
                                    pAnswers++;
                                    incorrectAnswers++;
                                    break;
                                case ANSWER4:
                                    nAnswers++;
                                    incorrectAnswers++;
                                    break;
                            }
                        } else {
                            if (obj.answer_type == CORRECTANSWER) correctAnswers++;
                            else incorrectAnswers++;
                        }

                        points += obj.points;
                    });

                    var template = Handlebars.compile($("#gameSummaryModal").html());
                    var context = {
                        game: request.game,
                        totalAnswers: totalAnswers,
                        correctAnswers: correctAnswers,
                        incorrectAnswers: incorrectAnswers,
                        mAnswers: mAnswers,
                        bAnswers: bAnswers,
                        pAnswers: pAnswers,
                        nAnswers: nAnswers,
                        points: Math.round(points * 100) / 100,
                        worldMode: world.world_mode,
                        level: response.result.user.level
                    };

                    $("#modalContainer").html(template(context)).modal('show');

                    $('#resumen-partido').attr('data-dimension', $(window).width() <= 420 ? '138' : '188')
                    $('#modal-circle-progress-info-text').dotdotdot({
                        height: $(window).width() <= 420 ? 40 : 60,
                        truncate: 'letter',
                        watch: true,
                    });


                    if (world.world_mode === 'ASSESSMENT') {
                        createGameSummaryChart($('#resumen-partido-assessment'), mAnswers,
                            bAnswers, pAnswers, nAnswers, totalAnswers);
                    } else {
                        $('#resumen-partido').circliful({
                            adjustToContainer: true
                        });
                    }

                    $(document).one('click', '.modal-close-btn, .modal-accept-btn', function (e) {
                        $("#modalContainer").modal('hide').empty();
                        $(document).off('click', '.modal-close-btn, .modal-accept-btn');

                        api.login(
                            window.blackBox.getAvatar(),
                            window.blackBox.getPhrase(),
                            false,
                            null,
                            false,
                            false,
                            false,
                            () => {
                                if(world?.mode === "newLayout") {
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 300);
                                }
                            }
                        );
                    });
                }
            }
        });
    };

    sendCompleteDocumentGame(request, documentId) {

        const that = this;
        const request_data = JSON.stringify(request);

        $.ajax({
            type: "POST",
            // IZE-9629 (FR-023): antes `game_document_own_comlpete_game` (/document-own-game/{id}/complete).
            // Backend renombra el endpoint a /register; `completion-game-check`/`completion-test-check`
            // quedan obsoletos y no llegaron a usarse desde este repo (nunca hubo paso de verificación
            // previa real: este mismo endpoint ya decidía y persistía la completitud en su respuesta).
            url: Routing.generate('game_document_own_register_game', {worldHelpLinkId: documentId}),
            data: request_data,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (!that.checkisValidResult(response)) {
                    console.trace(response);
                    return;
                }

                try {
                    const timeoutModal = 3000;

                    if (documentObj.own_game) {
                        response.result.current_game_answered_questions = _.countBy(request.game.questions, function (question) {
                            return question.answer_type !== playScreenController.getTimeOutId();
                        }).true

                        const documentGameResults = new DocumentGameResults();

                        documentGameResults.updateGameDocument(response.result);
                        documentGameResults.showResultsPopUp();

                        setTimeout(function () {
                            documentGameResults.hideResultsPopUp();

                            setTimeout(function () {

                                if (documentObj.is_path_content && documentObj.own_game.is_path_assessment_game) {
                                    documentGameResults.showAssessmentResultsPopUp();
                                } else {
                                    documentGameResults.goToMainApp();
                                }

                            }, popUpController.getAnimationSpeed());

                        }, timeoutModal);

                    } else if (documentObj.own_test) {
                        const documentTestResults = new DocumentTestResults();

                        documentTestResults.updateTestDocument(response.result);
                        documentTestResults.showResultsModal();

                        setTimeout(function () {
                            documentTestResults.hideResultsModal();
                            documentTestResults.setDocumentCompleted(response.result);

                            if (documentObj.is_path_content && documentObj.own_test.is_path_assessment_test) {
                                documentTestResults.showAssessmentResultsPopUp();
                            } else {
                                documentTestResults.goToMainApp();
                            }

                        }, timeoutModal);

                    } else if (documentObj.own_poll) {
                        const documentPollResults = new DocumentPollResults();

                        documentPollResults.updatePollDocument(response.result);
                        documentPollResults.goToMainApp();
                    }
                } catch (e) {
                    console.trace('catch:', e);
                    const documentGameResults = new DocumentGameResults();
                    documentGameResults.goToMainApp();
                }
            },
            error: function (response) {
                console.trace('error', response);
                if (documentObj.own_game) {
                    const documentGameResults = new DocumentGameResults();

                    if (documentObj.is_path_content && documentObj.own_game.is_path_assessment_game) {
                        documentGameResults.showAssessmentResultsPopUp();
                    } else {
                        documentGameResults.goToMainApp();
                    }
                } else if (documentObj.own_test) {
                    const documentTestResults = new DocumentTestResults();

                    if (documentObj.is_path_content && documentObj.own_test.is_path_assessment_test) {
                        documentTestResults.showAssessmentResultsPopUp();
                    } else {
                        documentTestResults.goToMainApp();
                    }
                } else {
                    const documentPollResults = new DocumentPollResults();
                    documentPollResults.goToMainApp();
                }
            }
        });

    }

    sendCompleteDocTest(request) {

        var that = this;
        var request_data = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('documentation_complete_game'),
            data: request_data,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    if (inIframe()) {
                        response.msj = 'complete';
                        window.parent.postMessage(response, '*');
                    }
                    // Contamos el número de preguntas totales, correctas e incorrectas, y sumamos los puntos.
                    var correctAnswers = 0, incorrectAnswers = 0, points = 0;
                    var template, context;
                    var totalAnswers = request.game.questions.length;
                    $.each(request.game.questions, function (i, obj) {
                        if (obj.answer_type == CORRECTANSWER) correctAnswers++;
                        else incorrectAnswers++;
                        points += obj.points;
                    });

                    if (documentObj.has_test) {
                        template = Handlebars.compile($("#testSummaryModal").html());
                        context = {
                            game: response.result.game,
                            gameQualification: Math.round((response.result.game.qualification + Number.EPSILON) * 100) / 100,
                            document: documentObj,
                            totalAnswers: totalAnswers,
                            correctAnswers: correctAnswers,
                            incorrectAnswers: incorrectAnswers,
                            success: response.result.game.qualification >= documentObj.minimum_qualification ? true : false,
                            color: response.result.game.qualification >= documentObj.minimum_qualification ? '#4caf50' : '#f44336',
                            totalPoints: response.result.game.total_points
                        };
                    } else {
                        template = Handlebars.compile($("#gameSummaryModal").html());

                        request.game.category = {};
                        request.game.category.icon = documentObj.icon_type;
                        request.game.category.color = world.theme.color_1;
                        request.game.category.name = documentObj.name;

                        context = {
                            game: request.game,
                            totalAnswers: totalAnswers,
                            correctAnswers: correctAnswers,
                            incorrectAnswers: incorrectAnswers,
                            points: points.toLocaleString("es-ES")
                        };
                    }

                    $("#modalContainer").html(template(context)).modal('show');
                    $('#resumen-partido').attr('data-dimension', $(window).width() <= 420 ? '138' : '188');
                    $('#resumen-partido').circliful({
                        adjustToContainer: true
                    });

                    $(document).one('click', '.modal-close-btn, .modal-accept-btn', function (e) {
                        $("#modalContainer").modal('hide').empty();
                        $(document).off('click', '.modal-close-btn, .modal-accept-btn');

                        let template = Handlebars.compile($("#baseScreen").html());

                        $("#mainContainer").html(template(world));
                        baseController.draw(world.theme);

                        let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

                        if (documentOpenedInChat) {

                            let document = documentationScreenController.getDocument(chatScreenController.openedProjectDocumentMessage.id);
                            let parentFolder = document.folder;

                            documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);
                            documentObj = null;

                        } else {
                            if (baseController.currentActiveTab.id === new Tabs().LINKS_TAB) {
                                api.getFolderDocuments(null, 0, documentationScreenController.documentationPageSize, function (response) {
                                    documentationScreenController.openDocumentation(response.result);
                                });
                            } else {
                                baseController.selectedTabAction(baseController.currentActiveTab.world_tab_id);
                            }
                        }


                    });
                }
            }
        });
    };

    sendCompleteChallenge(request) {

        var that = this;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('complete_duel_game'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {


                    if (inIframe()) {
                        response.msj = 'complete';
                        window.parent.postMessage(response, '*')
                    }

                    var template;
                    var result = response.result;

                    result.game.points = result.game.points.toLocaleString('es-ES');
                    result.starIcon = customIcons["BET_ICON"];

                    template = Handlebars.compile($("#worldChallengeResumeModal").html());

                    // This solves the bug: https://iseazy-engage.atlassian.net/browse/IZE-5547
                    $("#modalContainer").html(template(result));
                    $('#modalContainer').modal('show');

                    
                }
            }
        });
    };

    getGameDocumentPollData(documentId, gameId) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('game_document_own_poll_data', {
                worldHelpLinkId: documentId,
                gameDocumentOwnId: gameId
            }),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    let template = null;
                    const result = response.result;

                    result.own_poll = documentObj.own_poll;
                    result.poll_end_resume = true;

                    playScreenController = new PlayScreenController(result, false);
                    template = Handlebars.compile($("#worldPollScreen").html());

                    $("#mainContainer").html(template({
                        pollName: documentObj.name,
                        pollColor: documentObj.own_poll.color,
                    }));

                    playScreenController.drawPoll(result);

                    $('#documentation-header-close-btn').one('click.closePoll', function () {

                        let template = Handlebars.compile($("#baseScreen").html());
                        $("#mainContainer").html(template(world));
                        baseController.draw(world.theme);

                        let document = documentationScreenController.getDocument(result.document_id);
                        let parentFolder = documentationScreenController.getParentFolder(result.document_id, documentationScreenController.documentation);

                        if (baseController.currentActiveTab.id === new Tabs().LINKS_TAB) {
                            // FIX Al cerrar el cuestionario las petañas de la web y el contenido no se engancha al html.
                            setTimeout(function () {
                                documentationScreenController.openDocumentation(documentationScreenController.documentation, null, null, false);
                                documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);
                            }, 1);
                        } else {
                            documentObj = null;
                            baseController.selectedTabAction(baseController.currentActiveTab.world_tab_id);
                        }

                    });

                }
            }
        });

    }

    getnewGameCategories(token, question_category_parent_id, action, isChildren = false) {

        var that = this;
        var url = 'world_categories';

        if (action == 'EDITQUESTION') {
            url = 'question_categories';
        }

        $.ajax({
            type: "POST",
            url: Routing.generate(url, {world_token: token, question_category_parent_id: question_category_parent_id}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    chooseCategoryFullModalController.draw(response.result, question_category_parent_id, action, isChildren);
                }
            }
        });
    };


    getGlobalBackground() {
        var that = this;
        $.ajax({
            type: "POST",
            url: Routing.generate('global_background'),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {

                let template = Handlebars.compile($("#tokenScreen").html());

                if (response.success) {
                    let background = response.result.background;
                    $("#mainContainer").html(template({data: response.result}));
                } else {
                    $("#mainContainer").html(template());
                }
            }
        });
    };

    checkRegistrationType(worldToken, onResult, onError) {
        $.ajax({
            type: "GET",
            url: Routing.generate('registration_check_type', {token: worldToken}),
            cache: false,
            success: function (response) {
                if (typeof onResult === 'function') onResult(response);
            },
            error: function (jqXHR) {
                if (typeof onError === 'function') onError(jqXHR);
            }
        });
    };
    
    // El callback se ejecutará luego del login, para redirigir al recurso seleccionado
    getWorldTheme(token, is_lms, callback = null) {
        var that = this;
        var template;
        $.ajax({
            type: "POST",
            url: Routing.generate('world_theme', {world_token: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (!that.checkisValidResult(response, false)) {
                    console.trace('world_theme is not valid result: ', response);
                    // If we have KC access token, try to continue login instead of stopping here
                    if (typeof keycloakAuth !== 'undefined' && keycloakAuth.accessToken) {
                        api.login(window.blackBox.getAvatar() || '', null, false, keycloakAuth.accessToken);
                        return;
                    }
                    return;
                }

                var result = response.result;
                var loginWithGoogleEnabled = result.brand.google_client_id.active;
                // var loginWithGoogleEnabled = true
                var googleClientId = loginWithGoogleEnabled ? result.brand.google_client_id.platforms.web : null;

                api.generateWorldData(result, is_lms);

                let sendData = {'world_token': token, 'show_all': 1};
                $.ajax({
                    type: "GET",
                    url: Routing.generate('api_get_custom_icons', sendData),
                    beforeSend: function (jqXHR, settings) {
                        settings.data = that.addAccessToken(settings);
                        that.sendHeader(jqXHR, true);
                    },
                    success: function (response) {
                        api.getCustomTranslations(false, null, 1, null, function () {
                            if (result.login_username != null) {
                                window.blackBox.setAvatar(result.login_username)

                                api.login(result.login_username, window.blackBox.getPhrase(), false, token);
                            } else {                               
                                // Resolve IDAM/Keycloak info for this world
                                $.ajax({
                                    type: "GET",
                                    url: "/api/v2/idam/info",
                                    cache: false,
                                    data: { world: token },
                                    success: function (idamInfo) {
                                        // Fix: Check for world mismatch before updating
                                        if (typeof keycloakAuth !== 'undefined' && keycloakAuth.worldToken && keycloakAuth.worldToken !== token) {
                                            if (typeof kc_clearStorage === 'function') {
                                                kc_clearStorage();
                                            } else {
                                                keycloakAuth.accessToken = null;
                                                keycloakAuth.worldToken = null;
                                            }
                                        }

                                        try {
                                            if (idamInfo && idamInfo.client_id) {
                                                if (typeof kc_setClientAndWorld === 'function') {
                                                    kc_setClientAndWorld(idamInfo.client_id, token);
                                                }
                                            }
                                        } catch (e) {}

                                        // If we already have an OAuth token, proceed without redirecting again
                                        if (typeof keycloakAuth !== 'undefined' && keycloakAuth.accessToken) {
                                            console.log('===> window.blackBox.getAvatar(): ', window.blackBox.getAvatar())
                                            console.log('===> keycloakAuth: ', keycloakAuth)
                                            console.log('===> keycloakAuth.accessToken: ', keycloakAuth.accessToken)
                                            api.login(window.blackBox.getAvatar() || '', null, false, keycloakAuth.accessToken);
                                            return;
                                        }

                                        if (idamInfo && idamInfo.has_idp && idamInfo.endpoint) {
                                            // Redirect to external IdP (Keycloak)
                                            location.href = idamInfo.endpoint;
                                            return;
                                        }

                                        // No external IdP, render legacy login (credentials)
                                        customIcons = response.icons;
                                        template = Handlebars.compile($("#loginScreen").html());
                                        var context = {
                                            world: world,
                                            icon: customIcons['TRAINING_COMPLETED'],
                                            googleClientId: googleClientId,
                                        };

                                        let doLogin = function (authProtocol, worldToken) {
                                            // console.log("🚀 ~ Api ~ doLogin ~ worldToken:", worldToken)
                                            // console.log("🚀 ~ Api ~ doLogin ~ authProtocol:", authProtocol)
                                            if (authProtocol) {
                                                location.href = Routing.generate('front_third_party_loggin') + "?world_token=" + worldToken;
                                            } else {
                                                context.eyeOffIcon = customIcons['LOGIN_EYE_OFF_ICON'];
                                                context.eyeOnIcon = customIcons['LOGIN_EYE_ON_ICON'];
                                                context.passIcon = customIcons['LOGIN_PASSWORD_ICON'];
                                                context.userIcon = customIcons['LOGIN_USER_ICON'];
                                                $("#mainContainer").html(template(context));
                                                loginController.draw(world.theme);
                                                callback ? callback() : null;
                                            }
                                        };

                                        api.getWorldAuthProtocols(world.token, doLogin);
                                        // context.eyeOffIcon = customIcons['LOGIN_EYE_OFF_ICON'];
                                        // context.eyeOnIcon = customIcons['LOGIN_EYE_ON_ICON'];
                                        // context.passIcon = customIcons['LOGIN_PASSWORD_ICON'];
                                        // context.userIcon = customIcons['LOGIN_USER_ICON'];
                                        // $("#mainContainer").html(template(context));
                                        // loginController.draw(world.theme);
                                        // callback ? callback() : null;
                                    },
                                    error: function () {
                                        // Fallback to legacy login
                                        customIcons = response.icons;
                                        template = Handlebars.compile($("#loginScreen").html());
                                        var context = {
                                            world: world,
                                            icon: customIcons['TRAINING_COMPLETED'],
                                            googleClientId: googleClientId,
                                        };
                                        context.eyeOffIcon = customIcons['LOGIN_EYE_OFF_ICON'];
                                        context.eyeOnIcon = customIcons['LOGIN_EYE_ON_ICON'];
                                        context.passIcon = customIcons['LOGIN_PASSWORD_ICON'];
                                        context.userIcon = customIcons['LOGIN_USER_ICON'];
                                        $("#mainContainer").html(template(context));
                                        loginController.draw(world.theme);
                                        callback ? callback() : null;
                                    }
                                });
                            }
                        });
                    }
                });
            },
            error: function (e) {
                console.trace('Error, world_theme: ', e);

                if (window.Sentry && e && e.status >= 500) {
                    Sentry.captureMessage('API error: world_theme', {
                        level: 'error',
                        fingerprint: ['api-error', 'world_theme', String(e.status)],
                        extra: {status: e.status, statusText: e.statusText},
                    });
                }
            }
        });
    };

    getWorldThemeAdminPreview(token) {
        var that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate('world_theme', {world_token: token, isDemo: 1}),
            beforeSend: function beforeSend(jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function success(response) {

                if (that.checkisValidResult(response, true)) {

                    var result = response.result;
                    api.generateWorldData(result, false);
                    api.getCustomTranslations(false, null, 1, null, function () {
                        api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                    });
                }
            }
        });
    };


    generateWorldData(result, is_lms) {

        if (result.preferred_language != systemLocale) {
            systemLocale = result.preferred_language;
            if ($.inArray(systemLocale, validLanguages) < 0) {
                systemLocale = validLanguages[0];
            }
        }

        loadTranslator(systemLocale);

        world = new World(result.world);

        theme = new Theme(result.theme);
        world.theme = theme;
        world.analytics_code = result.analytics_code;
        if (result.world.world_token) {
            world.token = result.world.world_token;
        }
        if (result.world.token) {
            world.token = result.world.token;
        }

        world.preferred_language = result.preferred_language;
        world.reset_password_url = result.reset_password_url;

        world.segmentation = result.categories;
        world.privacy_policy_enabled = result.world.privacy_policy_enabled;
        world.privacy_policy_checkox = result.world.privacy_policy_checkbox;
        world.privacy_policy_text = result.world.world_brand_privacy;
        world.privacy_policy_title = result.world.privacy_policy_title;

        world.use_policy_enabled = result.world.use_policy_enabled;
        world.use_policy_checkbox = result.world.use_policy_checkbox;
        world.use_policy_text = result.world.use_policy_text;
        world.use_policy_title = result.world.use_policy_title;

        world.register_form_fields = result.world.world_register_customization_form;
        world.checkboxes = result.world.checkboxes;

        analytics = new Analytics(world.analytics_code);
        world.is_lms = is_lms;
        addThemeStyles(theme);

        world.world_integration = result.world_integration;
        world.share_times = result.world.share_times;
        world.login_with_country = result.login_with_country;
        world.user_countries = result.user_countries;

        api.registrationTypeCheck = null;
        if (world.is_public) {
            api.checkRegistrationType(world.token, function (response) {
                api.registrationTypeCheck = response || null;
            });
        }

        //Lo guardamos en el almacenamiento local
        storage.setItem('world', encodeURIComponent(JSON.stringify(world)));
    };

    updateProfile(world_token, image, alias, name, lastName, email, phone, webNotifications, password, currentPassword = null, navigatorLanguage, onSuccess, onFailure) {
        var that = this;
        var user = {};

        user.username = alias ? alias : null;
        user.name = name ? name : null;
        user.last_name = lastName ? lastName : null;
        user.phone = phone ? phone : null;
        user.language = navigatorLanguage;

        if (typeof password != 'undefined' && password != '') {
            user.password = md5(password);
            user.shaPassword = sha256(password);
        }

        if (typeof webNotifications != 'undefined') {
            user.webnotifications = webNotifications;
        }

        if (email) {
            user.email = email;
        }

        if(currentPassword){
            user.current_password = currentPassword;
        }

        let request = {
            world_token: world_token,
            image: image,
            user: user
        };

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('update_user_data'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {

                if (that.checkisValidResult(response)) {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'SUCCESS');

                    user = new User(response.result.user);

                    if (onSuccess) onSuccess();

                } else {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'ERROR');

                    if (onFailure) onFailure();
                }

            }
        });
    }

    updateEmailProfile(world_token, email, currentPassword , onSuccess, onFailure) {
        var that = this;
        var user = {};

        if (email) {
            user.email = email;
        }

        if(currentPassword){
            user.current_password = currentPassword;
        }

        let request = {
            world_token: world_token,
            user: user
        };

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('update_user_data'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'SUCCESS');

                    user = new User(response.result.user);

                    if (onSuccess) onSuccess();

                } else {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'ERROR');

                    if (onFailure) onFailure();
                }
            }
        });
    }

    updateUserPassword(world_token, password, currentPassword, onSuccess, onFailure) {

        var that = this;
        var user = {};

        if (password !== '') {
            user.password = md5(password);
            user.shaPassword = sha256(password);
        }

        if (currentPassword !== '') {
            user.current_password = currentPassword;
        }

        var request = {
            world_token: world_token,
            user: user
        };
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('update_user_data'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'SUCCESS');
                    user = new User(response.result.user);

                    window.blackBox.setPhrase('ads', password);

                    if (onSuccess) onSuccess();
                } else {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'ERROR');
                    if (onFailure) onFailure();
                }
            }
        });
    }

    postUserInfo(world_token, userName, name, lastName, image, webnotifications, after, password, email, showFeedback = false) {

        var that = this;
        var request = new Object();
        var userI = new Object();

        if (!after) {
            after = 'PROFILE';
        }

        if (userName) {
            userI.username = userName;
        }
        if (webnotifications) {
            userI.webnotifications = webnotifications;
        }
        if (name) {
            userI.name = name;
        }
        if (lastName) {
            userI.last_name = lastName;
        }
        if (image) {
            request.image = image;
        }

        if (password) {
            userI.password = md5(password);
            userI.shaPassword = sha256(password);
        }

        if (email) {
            userI.email = email;
        }


        request.world_token = world_token;
        request.user = userI;


        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('update_user_data'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {

                var isValidResult;
                if (after == "STOP") {
                    isValidResult = that.checkisValidResultAndStop(response);
                    if (!isValidResult) {
                        swal.showInputError(Translator.trans("TR_EMAIL_ALREADY_EXISTS"));

                        return false;
                    }

                } else {
                    isValidResult = that.checkisValidResult(response, false, false);
                }

                if (isValidResult) {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'SUCCESS');
                    user = new User(response.result.user);

                    if (userI.password) {
                        window.blackBox.setPhrase('ads', password);
                    }
                    if (email) {
                        swal.close();
                    }

                    if (after == 'PROFILE') {
                        api.getUserProfile(world_token, user.user_world_id);
                    }
                    if (after == 'MENU') {
                        api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                    }
                } else {
                    ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_UPDATE_PROFILE, 'ERROR');
                }

                if (showFeedback) {
                    swal({
                        title: "",
                        text: Translator.trans('TR_CONTRASENYA_ACTUALIZADA'),
                        confirmButtonText: Translator.trans('TR_ACEPTAR'),
                        closeOnConfirm: true,
                        html: true
                    });
                }

            }
        });
    };

    getUserProfile(token, user_world_id, isChat = false) {
        var that = this;

        function getProfile() {
            var request = new Object();
            var isCurrentUser = true;
            request.world_token = token;

            if (user.user_world_id !== user_world_id) {
                request.user_world_id = user_world_id;
                isCurrentUser = false;
            }
            request = JSON.stringify(request);

            $.ajax({
                type: "POST",
                url: Routing.generate('basic_profile_detailed', {world_token: token}),
                data: request,
                beforeSend: function (jqXHR, settings) {
                    settings.data = that.addAccessToken(settings);
                    that.sendHeader(jqXHR, true)
                },
                success: function (response) {
                    if (that.checkisValidResult(response)) {

                        if (response.result.user.user_world_id !== user_world_id) {
                            swal({
                                title: "",
                                text: Translator.trans('TR_USUARIO_ELIMINADO'),
                                type: 'warning',
                                confirmButtonText: ''
                            });
                        } else {

                            var result = response.result;

                            result.user.points = result.user.points.toLocaleString('es-ES');

                            for (let index in result.rankings) {
                                let floatedPoints = parseFloat(result.rankings[index].ranking.points);

                                if (result.rankings[index].ranking.pointsUnit == 'SECONDS')
                                    floatedPoints = Math.round(floatedPoints / 10) / 100;

                                result.rankings[index].ranking.points = floatedPoints.toLocaleString("es-ES");

                            }

                            // Obtener el token de la gráfica
                            that.getChartToken(function (responseToken) {
                                profileScreenController.draw(result, isCurrentUser, isChat, responseToken.token);
                            });

                        }

                    }
                }
            });
        }

        if (!chartSocket) {
            chartSocket = this.quizSoquet();
        }

        if (world.profile_customization.show_opponent_profile || user.user_world_id === user_world_id) {
            getProfile();
        }

    };

    getWorldTokens(email) {
        var that = this;
        var request = new Object();
        request.email = email;
        request = JSON.stringify(request);
        $.ajax({
            type: "POST",
            url: Routing.generate('world_tokens'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    swal("", response.message, "success");
                } else {
                    swal("", response.message, "warning");
                }
            }
        });
    };

    getWorldHelpImages(token) {

        var that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate('world_help_screens', {worldToken: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    var template;
                    var result = response.result;

                    if (result.world_help_screens.length > 0) {
                        result.world_help_screens.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        template = Handlebars.compile($("#worldHelpImagesModal").html());
                        $("#modalHelpLinksImages").html(template(result));
                        $('#modalHelpLinksImages').modal('show');
                    }
                }
            }
        });
    };

    getUserDocumentation(token, published, onSuccess, showModal = true) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('user_world_help_link_published_list', {worldToken: token}),
            data: {published: published},
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal)
            },
            success: function (response) {
                response.result.published = published;

                _.forEach(response.result.documents, function (document) {
                    document.location = documentationScreenController.documentsRoutes[document.id];
                    document.progressState = documentationScreenController.documentationProgress.getProgressState(document);
                });

                onSuccess(response);
            }
        });

    }

    checkDocumentationLink(url, onSuccess, showModal = true) {

        var that = this;
        let route = 'documentation_link_checker';

        $.ajax({
            type: "GET",
            url: Routing.generate(route),
            data: {url: url},
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccess
        });

    }

    getWorldAchievments(token) {

        var that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate('world_achievements', {world_token: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    var template;
                    var result = response.result;
                    template = Handlebars.compile($("#worldAchievmentsModal").html());
                    $("#modalHelpLinksImages").html(template(result));
                    $('#modalHelpLinksImages').modal('show');

                    $(".tintedCanvas").each(function () {
                        tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
                    });

                }
            }
        });
    };

    getWorldLevels(token) {

        var that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate('world_levels', {world_token: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    var template;
                    var result = response.result;


                    // Nivel del usuario?
                    let userLevel = 0;
                    for (let i = 0; i < result.levels.length; i++) {
                        if (result.levels[i].user_level) {
                            userLevel = result.levels[i].level;
                            break;
                        }
                    }

                    // Diferencia de niveles
                    for (let i = 0; i < result.levels.length; i++) {
                        result.levels[i].level_diff = result.levels[i].level - userLevel;
                    }

                    // Ordenamos los niveles de mayor a menor
                    result.levels.reverse();
                    result.levelIcon = customIcons["UNKNOWN_LEVEL_LIST"];

                    $(document).one('click', '.modal-close-btn', function () {
                        $("#modalContainer").modal('hide').empty();
                        $(document).off('click', '.modal-close-btn');
                    });

                    template = Handlebars.compile($("#worldLevelsModal").html());
                    $("#modalContainer").html(template({
                        'worldMode': world.world_mode,
                        'levelsData': result
                    })).modal('show');

                    $('.level-info-name').dotdotdot({
                        wrap: 'letter',
                        watch: true,
                        height: 50
                    });
                    ga('send', 'pageview', analytics.GA_SCREEN_LEVELS);
                }
            }
        });
    };

    getLegalInfo(onSuccess) {
        var that = this;
        $.ajax({
            type: "POST",
            url: Routing.generate('legal_info', {world_token: world.token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: onSuccess
        });
    }

    getLevelProgress(onSuccess) {
        var that = this;
        $.ajax({
            type: "POST",
            url: Routing.generate('user_get_level_infomation', {world_token: world.token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: onSuccess
        });
    };

    getQuestionStats(token, showLoader) {

        var that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate('question_statistics', {world_token: token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showLoader);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    let context = {result: response.result, world: world};
                    myQuestionsController.draw(context);
                }
            }
        });
    };

    getQuestionInfo(token, question_id, showLoader) {
        var that = this;
        var request = new Object();


        request.world_token = token;
        request.question_id = question_id;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('question_information'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showLoader);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    let context = response.result;
                    let ratingMedia = parseFloat(response.result.question_median).toFixed(2);

                    context['question_median_round'] = Math.ceil(context.question_median);
                    context["question_median_percent"] = (ratingMedia * 100) / 5;

                    var template = Handlebars.compile($("#statusQuestionModal").html());
                    $("#modalContainer").html(template(context)).modal('show');

                    $('.smile-01').css('background-image', 'url(' + customIcons["RATE_SMILE_1"] + ')');
                    $('.smile-02').css('background-image', 'url(' + customIcons["RATE_SMILE_2"] + ')');
                    $('.smile-03').css('background-image', 'url(' + customIcons["RATE_SMILE_3"] + ')');
                    $('.smile-04').css('background-image', 'url(' + customIcons["RATE_SMILE_4"] + ')');
                    $('.smile-05').css('background-image', 'url(' + customIcons["RATE_SMILE_5"] + ')');

                    $(document).one('click', '.modal-close-btn, .modal-accept-btn', function () {
                        $("#modalContainer").modal('hide').empty();
                        $(document).off('click', '.modal-close-btn, .modal-accept-btn');
                    });

                    return false;
                }
            }
        });
    };

    addQuestion(token, category_id, question) {

        var that = this;
        var request = new Object();
        request.world_token = token;
        request.category_id = category_id;
        request.question = question;
        request = JSON.stringify(request);
        $.ajax({
            type: "POST",
            url: Routing.generate('add_question'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                $("#loadingContainerDiv svg").remove();
                $(".load-question-add-cell div").addClass("load-question-completed-border");

                if (that.checkisValidResult(response)) {
                    $('#addQuestionSplashTxt').text(Translator.trans('TR_PREGUNTA_ENVIADA_CORRECTAMENTE'));
                } else {
                    $('#addQuestionSplashTxt').text(Translator.trans('TR_ERROR_ANADIENDO_PREGUNTA'));
                }

                setTimeout(function () {
                    api.getQuestionStats(world.token, false)
                }, 500);
            }
        });
    };

    getReviewQuestions(token, category_id, limit, offset) {

        var that = this;
        var request = {};
        request.world_token = token;
        if (category_id != 0) {
            request.category_id = category_id;
        }
        request.limit = limit;
        request.offset = offset;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('list_pending_questions'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {

                    var result = response.result;

                    var categoryInfo = {};
                    $.each(world.categories, function (index, value) {
                        if (value.category.id == category_id) {
                            categoryInfo = {
                                name: value.category.name,
                                icon: value.category.icon,
                                color: value.category.color
                            };
                        }
                    });

                    if (result.questions.length == 0) {
                        swal({
                            title: "",
                            text: Translator.trans('TR_NO_EXISTEN_SUFICIENTES_PREGUNTAS_DE_ESTA_CATEGORIA'),
                            type: 'warning',
                            confirmButtonText: ''
                        });
                        return false;
                    }

                    reviewQuestionController = new ReviewQuestionFullModalController(result, categoryInfo);
                    reviewQuestionController.open();
                }
            }
        });
    };

    getCategoriesInfo(onSuccess) {

        let that = this;

        let request = {};
        request.world_token = world?.token;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('info_category'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: onSuccess
        });
    }

    increaseLoginNumber() {
        var that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('add_log_in', {user_world_id: user.user_world_id}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            }
        });
    }

    increaseDocumentViews(documentId) {

        const that = this;

        return $.ajax({
            type: "POST",
            url: Routing.generate('world_help_link_visualization_increase', {documentId: documentId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            }
        });

    }

    sendCompleteReview(request) {
        var that = this;
        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('correct_question'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    var result = response.result;
                    reviewQuestionController.showNextQuestion(result);
                }
            }
        });
    };

    checkisValidResult(data, exitWorld = false, deleteStorage = false) {

        var jsonObject = isJson(data) ? data : $.parseJSON(data);
        var logout = jsonObject.hasOwnProperty("logout") ? jsonObject.logout : false;

        if (!jsonObject.success) {
            if (jsonObject.hasOwnProperty("logout") && (!window.blackBox.getAvatar() && !window.blackBox.getPhrase())) {
                // No se tiene que mostrar la modal. Se ha deslogueado el usuario.
                return false;
            }

            //Dev code - Don't show alert in local
            if(window.location.href.includes('localhost:8080')) {
                return;
            }

            swal({
                title: "",
                text: jsonObject.message,
                type: 'warning',
                confirmButtonText: '',
                closeOnConfirm: true,
                allowEscapeKey: false
            }, function () {

                if (jsonObject.hasOwnProperty("logout") && logout) {
                    baseController.logout(null, exitWorld || $('#btnLogin').length === 0);
                    return false;
                }

                if (!jsonObject.hasOwnProperty("doesnt_exist_anymore")) {

                    if (jsonObject.access_denied) {
                        baseController.logout(null, exitWorld || $('#btnLogin').length === 0);
                        return false;
                    }

                    if (!logout && jsonObject.hasOwnProperty("return_home")) {
                        location.href = Routing.generate('front_office_homepage');
                        return false;
                    }

                    if (deleteStorage) {
                        removeUserAccessStorage();
                    }

                    if (exitWorld) {
                        storage.removeItem('world');
                        location.href = Routing.generate('front_office_homepage');
                    }
                }
                return false;
            });
        } else if (jsonObject.expired_password && welcomeScreenController) {
            welcomeScreenController.draw(jsonObject.result, true);
        } else {
            return true;
        }
    }

    checkisValidResultChallenge(data) {

        var jsonObject;
        jsonObject = data;
        if (!isJson(jsonObject)) {
            jsonObject = $.parseJSON(data);
        }


        if (!jsonObject.success) {
            swal({title: "", text: jsonObject.message, type: 'warning', confirmButtonText: ''}
                , function (isConfirm) {
                    api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                });
            return false;
        }
        return true;
    };

    checkisValidResultAndStop(data) {

        var jsonObject;
        jsonObject = data;
        if (!isJson(jsonObject)) {
            jsonObject = $.parseJSON(data);
        }
        if (!jsonObject.success) {

            return false;
        }
        return true;
    };

    addAccessToken(settings) {

        if (storage.getItem('access_token')) {
            try {
                var currentData = settings.data ? $.parseJSON(settings.data) : {};
                return JSON.stringify($.extend(currentData, {access_token: storage.getItem('access_token')}));
            } catch (e) {
                return settings.data;
            }
        }
        return settings.data;
    };

    sendHeader(xhr, showModal, xs, sendAccessToken = true, sendWorldToken = true) {
        var wsse;

        const accessToken = storage.getItem('access_token');
        const isExternalLogin = !!storage.getItem('external_login');

        if (sendAccessToken && accessToken && isExternalLogin) {
            // External login (Google/OAuth): send Bearer + WSSE with google token
            try {
                xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
            } catch (e) {}
            if (storage.getItem('google_access_token')) {
                wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), storage.getItem('google_access_token'));
            } else {
                wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), window.blackBox.getPhrase());
            }
        } else if (accessToken && !isExternalLogin) {
            // Platform login: use access_token for WSSE, no Bearer
            wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), accessToken);
        } else {
            wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), window.blackBox.getPhrase());
        }

        if (showModal && world?.mode !== "newLayout") {
            // Clean up any existing loading backdrops before showing new modal
            $('.loadingBackdrop').remove();
            $('#modalLoading').modal('show');
            // Wait for Bootstrap to create the backdrop element, then add the loading class
            setTimeout(() => {
                $('.modal-backdrop').last().addClass("loadingBackdrop");
            }, 50);
        }

        if (xs) {
            xhr.setRequestHeader("X-S", xs);
        }

        xhr.setRequestHeader("X-WSSE", wsse);
        xhr.setRequestHeader("webversion", true);
        xhr.setRequestHeader("language", navigatorLanguage);

        if (sendWorldToken && typeof (world) !== 'undefined') {
            var storageAccessToken = storage.getItem('access_token');

            // Keep world scoping with world.token, fallback to access tokens only if no world token defined
            if (world.token) {
                xhr.setRequestHeader("world-token", world.token);
            } else if (world.world_token) {
                xhr.setRequestHeader("world-token", world.world_token);
            } else if (world.access_token) {
                xhr.setRequestHeader("world-token", world.access_token);
            } else if (storageAccessToken) {
                xhr.setRequestHeader("world-token", storageAccessToken);
            }
        }

    }

    getHeader() {
        var wsse;

        const accessToken = storage.getItem('access_token');
        const isExternalLogin = !!storage.getItem('external_login');

        if (accessToken && isExternalLogin) {
            // External login (Google/OAuth): WSSE with google token or phrase
            if (storage.getItem('google_access_token')) {
                wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), storage.getItem('google_access_token'));
            } else {
                wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), window.blackBox.getPhrase());
            }
        } else if (accessToken && !isExternalLogin) {
            // Platform login: use access_token for WSSE
            wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), accessToken);
        } else {
            // Fallback: use phrase
            wsse = wsseHeaderEncoded(window.blackBox.getAvatar(), window.blackBox.getPhrase());
        }

        return wsse;
    }

    loadFirstTab(worldHomeController, template, baseController, worldTabs) {
        let visibleTabs = $.grep(worldTabs, (tab) => {
            return tab.visible;
        });

        visibleTabs.sort(function (tab1, tab2) {
            return (tab1.sort > tab2.sort) ? 1 : ((tab2.sort > tab1.sort) ? -1 : 0);
        });

        if (visibleTabs[0].id == 1) {
            this.loadPlayTab(worldHomeController, template, baseController);
        } else {
            baseController.selectedTabAction(visibleTabs[0].world_tab_id, visibleTabs[0].folder_tab_id);
        }
    }

    loadPlayTab(worldHomeController, template, baseController, callback = null) {
        let that = this;
        //pintar home screen
        template = Handlebars.compile($("#worldHomeScreen").html());
        let tabs = new Tabs();
        let tab = baseController.getTabById(tabs.JUGAR_TAB);

        // Hacer la llamada para obtener el token de la grafica
        this.getChartToken( (responseToken) => {
            var context = {world: world, user: user, token: responseToken.token};

            worldHomeController.setChallengeRequest(world?.token, null, null, null);

            baseController.showSlogan(tabs.JUGAR_TAB);
            baseController.drawMainMenu(tabs.JUGAR_TAB);
            baseController.stackView(tab, template, context);

            that.getCategoriesInfo(worldHomeController.drawKnowdelegeList.bind(that));

            let worldHomeLevelIcon = $('#worldHomeLevelIcon');
            worldHomeLevelIcon.attr('data-percent', Math.floor(worldHomeLevelIcon.attr('data-percent') * 100));
            worldHomeLevelIcon.attr('data-part', Math.floor(worldHomeLevelIcon.attr('data-part') * 100));
            worldHomeLevelIcon.attr('data-dimension', '105');
            worldHomeLevelIcon.circliful();
            worldHomeController.adjustHeight();

            const differenceBetweenContainer = 25;
            const challengeButton = $("#challengeBtn");
            const challengeButtonText = $(".play-text.is-challenge-button");
            // FIX las palabras que no quepan en el boton de retar tendran un tamaño inferior
            if (challengeButton.width() - challengeButtonText.width() <= differenceBetweenContainer) {
                challengeButtonText.addClass("is-small-text");
            }

            if (callback) {
                callback();
            }
        });
    }

    getDocumentComments(documentId, offset, limit, onSuccess) {

        const that = this;

        return $.ajax({
            type: "GET",
            url: Routing.generate('documentation_comments_2', {documentId: documentId}),
            data: {offset: offset, limit: limit},
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccess
        });
    }

    getSharedLinks(documentId, offset, limit) {
        let that = this;
        return $.ajax({
            type: "GET",
            url: Routing.generate('share_link_list', {
                worldToken: world.token,
                worldHelpLink: documentId,
                offset: offset,
                limit: limit
            }),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            }
        });
    }

    shareDocument(documentId) {
        let that = this;

        return $.ajax({
            type: "POST",
            url: Routing.generate('create_share_link', {world_help_link: documentId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            }
        });
    }

    deleteShareDocument(linkId, success) {
        let that = this;
        return $.ajax({
            type: "DELETE",
            url: Routing.generate('delete_share_link', {link_id: linkId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            }, success
        });
    }

    cancelShareDocument(documentId) {
        let that = this;

        return $.ajax({
            type: "POST",
            url: Routing.generate('disable_share_link', {world_help_link: documentId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            }
        });
    }

    uploadDocumentPreview(document, onSuccess, showModal) {

        ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_UPLOAD_DOCUMENT, '');

        const that = this;
        const formDataRequest = new FormData();

        formDataRequest.append("document", document);
        formDataRequest.append("world_token", world.token);

        $.ajax({
            type: 'POST',
            url: Routing.generate('documentation_upload_web'),
            contentType: false,
            processData: false,
            data: formDataRequest,
            timeout: 0,
            beforeSend: function (jqXHR, settings) {
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccess
        });

    }

    uploadDocument(documentData, onSuccess) {

        const that = this;

        $.ajax({
            type: 'POST',
            url: Routing.generate('documentation_upload'),
            contentType: false,
            processData: false,
            data: JSON.stringify(documentData),
            timeout: 0,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccess
        });

    }

    editDocument(documentData, onSuccess) {

        const that = this;

        $.ajax({
            type: 'PUT',
            url: Routing.generate('user_world_document_put', {worldToken: world.token, documentId: documentData.id}),
            contentType: false,
            processData: false,
            data: JSON.stringify(documentData),
            timeout: 0,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: onSuccess
        });

    }

    deleteDocument(documentId, onSuccess) {

        const that = this;

        return $.ajax({
            type: "DELETE",
            url: Routing.generate('user_world_document_delete', {worldToken: world.token, documentId: documentId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccess
        });

    }

    uploadChatDocument(document, documentExtension, documentName = null, documentChecksum = null, onProgressFunction, onCompletedFunction) {

        let that = this;
        let formData = new FormData();

        formData.append("document", document);
        formData.append("world_token", world.token);

        $.ajax({
            type: 'POST',
            url: Routing.generate('upload_user_document_web'),
            contentType: false,
            processData: false,
            data: formData,
            timeout: 0,
            beforeSend: function (jqXHR, settings) {
                that.sendHeader(jqXHR, false);
            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (e) {
                    onProgressFunction(e)
                }, false);
                return xhr;
            }
        }).done(function (response) {
            if (that.checkisValidResult(response)) {
                let data = JSON.stringify({
                    world_token: world.token,
                    extension: documentExtension,
                    document: response.result.url,
                    name: documentName,
                    uploaded: true
                });

                $.ajax({
                    type: 'POST',
                    url: Routing.generate('upload_user_document'),
                    contentType: false,
                    processData: false,
                    data: data,
                    timeout: 0,
                    beforeSend: function (jqXHR, settings) {
                        settings.data = that.addAccessToken(settings);
                        that.sendHeader(jqXHR, false);
                    }
                }).done(function (response) {
                    if (that.checkisValidResult(response)) {
                        onCompletedFunction(response);
                    }
                });
            }
        })

    }

    markNotificationRead(world_token) {
        var that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate('mark_notification_read', {'world_token': world_token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false)
            }
        });
    };

    getDetailedUserCompletion(world_token, onSuccess) {
        var that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate('user_completion'),
            data: JSON.stringify({'world_token': world_token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccess
        });
    }

    getWorldAuthProtocols(worldToken, cbFn) {
        // console.log("🚀 ~ Api ~ getWorldAuthProtocols ~ worldToken:", worldToken);
        // console.log("🚀 ~ Api ~ getWorldAuthProtocols ~ cbFn:", cbFn);
        let that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('get_world_auth_protocols', {'world_token': worldToken}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                // console.log("🚀 ~ Api ~ getWorldAuthProtocols ~ settings:", settings);
                that.sendHeader(jqXHR, false)
            },
            success: function (response) {
                // console.log("🚀 ~ Api ~ getWorldAuthProtocols ~ response:", response);
                let responseData = response.data || {'authentication_protocol': null};
                let authProtocol = responseData.authentication_protocol || null;
                cbFn(authProtocol, worldToken);
            }, 
            error: function (e) {
                // console.log("🚀 ~ Api ~ getWorldAuthProtocols ~ e:", e);
            }
        })
    }

    getCustomTranslations(localeChanged, userData, allTranslations, currentWorld, callbackFunc) {
        let that = this;
        let currentVersion = storage.getItem('translation_version');

        if (localeChanged)
            allTranslations = 1;

        if (!currentWorld)
            currentWorld = world;

        if (currentWorld.translation_version != currentVersion || localeChanged) {
            let sendData = {'worldToken': currentWorld.token, 'allTranslations': allTranslations};

            if (userData)
                sendData['userWorldId'] = userData.user_world_id;

            if (!currentVersion)
                sendData['allTranslations'] = 1;

            $.ajax({
                type: "GET",
                url: Routing.generate('api_get_custom_translations', sendData),
                beforeSend: function (jqXHR, settings) {
                    settings.data = that.addAccessToken(settings);
                    that.sendHeader(jqXHR, true);
                },
                success: function (response) {
                    if (that.checkisValidResult(response)) {
                        storage.setItem('translation_version', response.translation_version);

                        let currentLocale = storage.getItem('locale') ? storage.getItem('locale') : systemLocale;

                        for (let key in response.translations) {
                            Translator.add(key, response.translations[key], "messages", currentLocale);
                        }

                        if (callbackFunc)
                            callbackFunc();
                    }
                }
            });
        } else if (callbackFunc) {
            callbackFunc();
        }
    }

    getCustomIcons(allIcons, token, callbackFunc) {
        let that = this;
        let sendData = {'world_token': token, 'show_all': allIcons ? 1 : 0};

        $.ajax({
            type: "GET",
            url: Routing.generate('api_get_custom_icons', sendData),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    customIcons = response.icons;
                    world.finderIcon = customIcons["FINDER_GLASS"];
                }
                if (callbackFunc) {
                    callbackFunc();
                }
            }
        });
    }

    _checkLanguageChanged(result, continueLogin) {
        let languageChanged = false;

        if (typeof (result.preferred_language) !== 'undefined' && result.preferred_language != systemLocale) {

            systemLocale = result.preferred_language;

            if ($.inArray(systemLocale, validLanguages) < 0) {
                systemLocale = validLanguages[0];
            }
            loadTranslator(systemLocale);

            languageChanged = true;
        }
        api.getCustomIcons(true, result.world.token, function () {
            api.getCustomTranslations(languageChanged, result.user.user_world_id, 0, result.world, continueLogin);
        });
    }

    rejectPolicies(privacyPolicy, usePolicy) {

        var that = this;

        if (privacyPolicy != null) {

            $.ajax({
                type: 'POST',
                url: Routing.generate('reject_privacy_policy'),
                data: JSON.stringify({world_token: world.token}),
                beforeSend: function (jqXHR, settings) {
                    settings.data = that.addAccessToken(settings);
                    that.sendHeader(jqXHR, true)
                },
            });

        }

        if (usePolicy != null) {

            $.ajax({
                type: 'DELETE',
                url: Routing.generate('user_reject_use_policy', {worldToken: world.token}),
                beforeSend: function (jqXHR, settings) {
                    settings.data = that.addAccessToken(settings);
                    that.sendHeader(jqXHR, true)
                },
            });

        }

    }

    confirmPolicies(privacyPolicy, usePolicy) {

        var that = this;

        if (privacyPolicy != null) {

            $.ajax({
                type: 'POST',
                url: Routing.generate('confirm_privacy_policy'),
                data: JSON.stringify({world_token: world.token}),
                beforeSend: function (jqXHR, settings) {
                    settings.data = that.addAccessToken(settings);
                    that.sendHeader(jqXHR, true)
                },
            });

        }

        if (usePolicy != null) {

            $.ajax({
                type: 'PUT',
                url: Routing.generate('user_accept_use_policy', {worldToken: world.token}),
                beforeSend: function (jqXHR, settings) {
                    settings.data = that.addAccessToken(settings);
                    that.sendHeader(jqXHR, true)
                },
            });

        }

    }

    getUserPolicies() {

        var privacyPolicy = JSON.parse(storage.getItem("privacyPolicy"));
        var usePolicy = JSON.parse(storage.getItem("usePolicy"));

        if (privacyPolicy.enabled && usePolicy.enabled) {

            welcomeScreenController.drawPolicies(privacyPolicy, usePolicy, false, false);

        } else if (privacyPolicy.enabled) {

            welcomeScreenController.drawPolicies(privacyPolicy, null, false, false);

        } else if (usePolicy.enabled) {

            welcomeScreenController.drawPolicies(null, usePolicy, false, false);

        }

    }

    getChats(onSuccess) {
        var that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('get_chat_rooms', {'worldToken': world.token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: onSuccess
        });
    }

    getChatRoom(callbackFunc, roomId, lastMessageId, batchSize) {
        var that = this;

        var params = {'roomId': roomId, 'startMessageId': lastMessageId};

        if (batchSize) {
            params.batchSize = batchSize;
        }

        $.ajax({
            type: "POST",
            url: Routing.generate('get_chat_room_messages', params),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    callbackFunc(response);
                }
            }
        });
    }

    getChatFriends(world_token, inputvalue, assistantView, callbackFunc) {
        let that = this;

        let request = {};
        request.world_token = world?.token;
        request.limit = 25;
        request.offset = 0;

        if (assistantView) {
            request.is_assistant = !assistantView;
        }

        if (inputvalue) {
            request.friend_username = inputvalue;
        }

        request = JSON.stringify(request);

        $.ajax({
            type: "POST",
            url: Routing.generate('get_user_friends'),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    let result = response.result;
                    result.inputValue = inputvalue;

                    let friendsList = [];

                    _.forEach(result.friends, function (friend) {
                        friendsList.push(friend.friend)
                    });

                    callbackFunc(friendsList);

                }
            }
        });
    };

    // Recuperar los datos de un documento subido por el usuario.
    getChatUserDocument(documentId, onSuccess) {

        let that = this;

        $.ajax({
            type: 'GET',
            url: Routing.generate('get_user_document', {documentId: documentId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccess
        });

    }

    // Recuperar una lista de documentos subidos por el usuario.
    getChatUserDocuments(documentIds, onSuccess) {

        let that = this;

        $.ajax({
            type: 'GET',
            url: Routing.generate('get_user_documents', {documentIds: documentIds}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccess
        });

    }

    fieldRequiredFields() {
        // Todos los campos requireds rellenos. Sino mostrar error
        var fieldRequired = true;
        var that = this;
        var fieldName;
        var errorText = '<ul>';
        $('#register-form input[type=text]').each(function () {
            if ($(this).prop('required') && $(this).val() === '') {
                fieldName = $(this).parent().find('label').text();
                fieldName = fieldName.slice(0, -1);
                errorText += '<li style="text-align: left">' + sprintf(Translator.trans('TR_CAMPO_OBLIGATORIO'), fieldName) + '</li>';
                fieldRequired = false;
                $(this).css('border', '2px solid red');
            }
        });
        $('#register-form input[type=checkbox]').each(function () {
            if ($(this).prop('required') && !$(this).is(":checked")) {
                fieldName = $(this).parent().find('label').text();
                fieldName = fieldName.slice(0, -1);
                errorText += '<li style="text-align: left">' + sprintf(Translator.trans('TR_CAMPO_OBLIGATORIO'), fieldName) + '</li>';
                fieldRequired = false;
                let label = $(this).labels()[0];
                $(label).css('color', 'red');
            }
        });
        $('#register-form select').each(function () {
            if ($(this).prop('required') && $(this).val() === null) {
                fieldName = $(this).parent().find('label').text();
                fieldName = fieldName.slice(0, -1);
                errorText += '<li style="text-align: left">' + sprintf(Translator.trans('TR_CAMPO_OBLIGATORIO'), fieldName) + '</li>';
                fieldRequired = false;
                $(this).css('border', '2px solid red');
            }
        });
        errorText += '</ul>';

        if (!fieldRequired) {
            swal({
                title: "",
                text: errorText,
                type: "warning",
                confirmButtonText: Translator.trans('TR_ACEPTAR'),
                closeOnConfirm: true,
                html: true
            });
        }
        return fieldRequired;
    }

    getCheckboxes() {
        // Añadir los checkboxes seleccionados como parámetro
        var checkboxSelect = [];
        $('#checks [type=checkbox]').each(function () {
            var checkbox = $(this).is(':checked');
            if (checkbox) {
                checkboxSelect.push($(this).attr('id').split('-')[1])
            }
        });
        return checkboxSelect;
    }

    getPolicyAccepted() {
        var color = $('#register-modal .modal-header').css("background-color");
        var policyAccepted = $("#privacy-policy")[0].checked;
        if (world.privacy_policy_enabled && !policyAccepted) {
            $('#privacy-policy-acceptance').addClass('is-rejected');
            swal({
                title: '',
                text: Translator.trans('TR_ACEPTAR_POLITICA'),
                type: "warning",
                confirmButtonText: Translator.trans('TR_ACEPTAR'),
                closeOnConfirm: true
            });
            return false;
        } else {
            $('#privacy-policy-acceptance').removeClass('is-rejected')
        }
        return policyAccepted;
    }

    getUsePolicyAccepted() {
        var policyAccepted = $('#use-policy')[0].checked;
        if (world.use_policy_enabled && !policyAccepted) {
            $('#use-policy-acceptance').addClass('is-rejected');
            swal({
                title: '',
                text: Translator.trans('TR_ACEPTAR_POLITICA_DE_USO'),
                type: 'warning',
                confirmButtonText: Translator.trans('TR_ACEPTAR'),
                closeOnConfirm: true
            });
            return false;
        } else {
            $('#use-policy-acceptance').removeClass('is-rejected');
        }
        return policyAccepted;
    }

    getCategories() {
        var categories = [];    // Array con los ids de las categorias
        $('#register-form select').each(function () {
            categories.push($(this).val());
        });
        return categories;
    }

    addInputText(firstName, lastName, email, buttonId, hidePwd) {
        $('#name').val(firstName);
        $('#last_name').val(lastName);
        $('#email').val(email);
        $('#userId').val(email);
        if (hidePwd) {
            $('#password-register-group').addClass('hidden');
            $('#key').removeAttr('required');
        }
        $('#registerBtn').attr('id', buttonId);
    }

    getChartToken(callback) {
        let that = this;
        // Obtener el token de la gráfica
        $.ajax({
            type: "GET",
            url: Routing.generate('chart_generate_token', {'worldToken': world?.token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true)
            },
            success: callback
        });
    }

    createSharedLink(sharedTimeId, sharedName, documentId, linkId = null, success) {
        var that = this;
        var request = new Object();
        request.name = sharedName;
        request.days = sharedTimeId;
        request = JSON.stringify(request);
        $.ajax({
            type: "POST",
            url: Routing.generate('create_share_link', {
                world_token: world.token,
                world_help_link: documentId,
                link_id: linkId
            }),
            data: request,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            }, success
        });
    }

    getUnreadMessages(rooms = []) {
        let unreadMessages = 0;
        let unreadUserMessages = 0;
        let unreadSupportMessages = 0;
        rooms.forEach(function (room) {
            // Numero de notificaciones totales
            unreadMessages += room.total_unread_messages;
            if (room.type === 4) {
                // Numero de notifucaciones soporte
                unreadSupportMessages += room.total_unread_messages;
            } else {
                // Numero de notificaciones usuario
                unreadUserMessages += room.total_unread_messages;
            }
        });

        let unreadMessagesData = {
            unreadMessages: unreadMessages,
            unreadUserMessages: unreadUserMessages,
            unreadSupportMessages: unreadSupportMessages
        }

        storage.setItem('chat_unread_messages', JSON.stringify(unreadMessagesData));

    }

    getDocumentTags(callback, showModal = true) {
        var that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate('world_document_tags', {worldToken: world.token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            }, success: callback
        });
    }

    getFinderDocuments(requestObject, onSuccessFunction) {

        const that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate("documentation_user_search"),
            data: JSON.stringify(requestObject),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    getRecentSearches(requestObject, onSuccessFunction) {

        const that = this;

        // Abortar la llamada anterior
        if (this.currentRequest != null) {
            this.currentRequest.abort();
        }

        this.currentRequest = $.ajax({
            type: "POST",
            url: Routing.generate("documentation_last_searches"),
            data: JSON.stringify(requestObject),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccessFunction
        });

    }

    getRecommendedSearches(requestObject, onSuccessFunction) {

        const that = this;

        // Abortar la llamada anterior
        if (this.currentRequest != null) {
            this.currentRequest.abort();
        }

        this.currentRequest = $.ajax({
            type: "POST",
            url: Routing.generate("documentation_get_suggestions"),
            data: JSON.stringify(requestObject),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccessFunction
        });

    }

    // External Assets ======================================================== //

    getPhotos(page, sortByPopularity, onSuccessFunction) {

        const that = this;
        const dataRequest = {
            world_token: world.token,
            page: page,
            popular: sortByPopularity
        }

        $.ajax({
            type: "POST",
            url: Routing.generate("external_assets_get_photos"),
            data: JSON.stringify(dataRequest),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    getTopics(onSuccessFunction) {

        const that = this;
        const dataRequest = {
            world_token: world.token
        }

        $.ajax({
            type: "POST",
            url: Routing.generate("external_assets_get_topics"),
            data: JSON.stringify(dataRequest),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    getTopicPhotos(page, topicId, onSuccessFunction) {

        const that = this;
        const dataRequest = {
            world_token: world.token,
            topic_id: topicId,
            page: page
        }

        $.ajax({
            type: "POST",
            url: Routing.generate("external_assets_get_topic_photos"),
            data: JSON.stringify(dataRequest),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    // El parametro upload es para subir la imagen directamente (Solo para el caso de pedir 1)
    getRandomPhotos(searchTerm, numberOfPhotos, documentType, onSuccessFunction, upload, showModal = true) {

        const that = this;
        const dataRequest = {
            world_token: world.token,
            count: numberOfPhotos,
            query: searchTerm,
            document_type: documentType
        }

        $.ajax({
            type: "POST",
            url: Routing.generate("external_assets_random_photos"),
            data: JSON.stringify(dataRequest),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: function (response) {

                if (upload) {

                    const photoId = response.result.photos[0].id;
                    const photoUrl = response.result.photos[0].url_regular;

                    api.uploadSelectedImage(photoId, photoUrl, onSuccessFunction, showModal);

                } else {
                    onSuccessFunction(response);
                }

            }
        });

    }

    searchPhotos(page, searchTerm, onSuccessFunction) {

        const that = this;
        const dataRequest = {
            world_token: world.token,
            page: page,
            query: searchTerm
        }

        $.ajax({
            type: "POST",
            url: Routing.generate("external_assets_search_photos"),
            data: JSON.stringify(dataRequest),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    uploadSelectedImage(photoId, photoUrl, onSuccessFunction, showModal = true) {

        const that = this;
        const dataRequest = {
            world_token: world.token,
            photo_id: photoId,
            url: photoUrl
        }

        $.ajax({
            type: "POST",
            url: Routing.generate("external_assets_upload_image"),
            data: JSON.stringify(dataRequest),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction
        });

    }

    // Type Content External ================================================== //

    getExternalContent(externalUrl, onSuccessFunction) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("cuatroochenta_api_content_external_get"),
            data: {url: externalUrl},
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    getExternalContentsProviders(onSuccessFunction) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("cuatroochenta_api_content_external_providersget"),
            data: {lang: storage.getItem("locale")},
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    uploadExternalContent(documentData, onSuccessFunction) {

        const that = this;

        $.ajax({
            type: 'POST',
            url: Routing.generate('cuatroochenta_api_content_external_post'),
            contentType: false,
            processData: false,
            data: JSON.stringify(documentData),
            timeout: 0,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    editExternalContent(documentData, onSuccessFunction) {

        const that = this;

        $.ajax({
            type: 'PUT',
            url: Routing.generate('cuatroochenta_api_content_external_put', {documentId: documentData.id}),
            contentType: false,
            processData: false,
            data: JSON.stringify(documentData),
            timeout: 0,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    getPath(pathId, onSuccessFunction, showModalLoading = true) {

        const that = this;

        // Los refrescos en segundo plano (showModalLoading=false) no deben abrir el loader: cada `show` extra
        // sin su `hide` dejaba backdrops huérfanos que bloqueaban la pantalla.
        if (showModalLoading) {
            $('#modalLoading').modal('show');
        }

        $.ajax({
            type: "GET",
            url: Routing.generate('cuatroochenta_api_path_get', {worldToken: world.token, pathId: pathId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModalLoading)
            },
            success: onSuccessFunction,
            always: function () {
                $('#modalLoading').modal('hide');
            }
        });

    }

    getPathItem(pathItemId, onSuccessFunction) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("cuatroochenta_api_path_item_get", {worldToken: world.token, pathItemId: pathItemId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, true);
            },
            success: onSuccessFunction
        });

    }

    getCompletedDocumentUsers(documentId, onSuccessFunction, showModalLoading = false) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("cuatroochenta_api_world_document_users_get", {
                worldToken: world.token,
                documentId: documentId
            }),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModalLoading);
            },
            success: onSuccessFunction
        });

    }

    getDocumentSocialActivity(documentId, paginationKey, requestFrom, onSuccessFunction) {

        const that = this;
        let requestData = null;

        if (paginationKey) {
            requestData = {
                "pagination-key": paginationKey,
                "from": requestFrom
            };
        }

        $.ajax({
            type: "GET",
            url: Routing.generate("cuatroochenta_api_social_activity_document", {documentId: documentId}),
            data: requestData,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccessFunction
        });

    }

    getDocumentUsersSocialActivity(documentId, activityType, searchText, onSuccessFunction, showModal = true) {

        const that = this;
        const requestData = {}

        if (searchText) {
            requestData.search_text = searchText;
        }

        $.ajax({
            type: "GET",
            url: Routing.generate("cuatroochenta_api_social_activity_document_users", {
                documentId: documentId,
                activityType: activityType
            }),
            data: requestData,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction
        });

    }

    getDocumentCommentLikes(commentId, searchText, onSuccessFunction, showModal = true) {

        const that = this;
        const requestData = {}

        if (searchText) {
            requestData.search_text = searchText;
        }

        $.ajax({
            type: "GET",
            url: Routing.generate("cuatroochenta_api_social_activity_comment_users", {commentId: commentId}),
            data: requestData,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction
        });

    }

    getUsersDirectory(userWorldIds, onSuccessFunction) {

        const that = this;
        const data = {
            user_world_ids: userWorldIds
        };

        $.ajax({
            type: "GET",
            url: Routing.generate("list_world_directory_users", {worldToken: world.token}),
            data: data,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccessFunction
        });

    }

    followUser(userWorldId, onSuccessFunction, showModal = true) {

        const that = this;

        $.ajax({
            type: "POST",
            url: Routing.generate("user_world_follow", {followingUserWorldId: userWorldId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction
        });

    }

    unfollowUser(userWorldId, onSuccessFunction, showModal = true) {

        const that = this;

        $.ajax({
            type: "DELETE",
            url: Routing.generate("user_world_unfollow", {followingUserWorldId: userWorldId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction
        });

    }

    getMentionsList(offset, limit, mention, onSuccessFunction) {

        const that = this;
        const data = {};

        if (offset) {
            data.offset = offset;
        }

        if (limit) {
            data.limit = limit;
        }

        if (mention) {
            data.mention = mention;
        }

        // Abortar la llamada anterior
        if (this.currentRequest != null) {
            this.currentRequest.abort();
        }

        this.currentRequest = $.ajax({
            type: "GET",
            url: Routing.generate("user_world_friends_mention_list", {worldToken: world.token}),
            data: data,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccessFunction
        });

    }

    getNotifications(offset = 0, limit = 20, searchText, onSuccessFunction, showModal = true) {

        const that = this;
        const data = {}

        if (offset) {
            data.offset = offset;
        }

        if (limit) {
            data.limit = limit;
        }

        if (searchText) {
            data.searchText = searchText;
        }

        $.ajax({
            type: "GET",
            url: Routing.generate("user_world_notification_list", {worldToken: world.token}),
            data: data,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction
        });

    }

    setNotificationReaded(userWorldNotificationId, onSuccessFunction, showModal = true) {

        const that = this;

        $.ajax({
            type: "PUT",
            url: Routing.generate('user_world_notification_mark_as_read', {
                worldToken: world.token,
                userWorldNotificationId: userWorldNotificationId
            }),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction
        });

    }

    setAllNotificationsReaded(onSuccessFunction) {

        const that = this;

        $.ajax({
            type: "PUT",
            url: Routing.generate('user_world_notification_mark_all_as_read', {
                worldToken: world.token
            }),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccessFunction
        });

    }

    // Obtener carpetas donde puedes subir documentación
    getAvailableUploadFolders(onSuccessFunction, showModal = true) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("world_documentation_upload_folders", {worldToken: world.token}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    onSuccessFunction(response);
                }
            }
        });

    }

    // Obtener la información de un documento
    getFolderInfo(folderId, onSuccessFunction, showModal = true) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("world_folder_by_id", {worldToken: world.token, folderId: folderId}),
            async: false,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    onSuccessFunction(response);
                }
            }
        });

    }

    // Obtener la información de un documento
    getDocumentInfo(documentId, onSuccessFunction, showModal = true, skipCheckResult = false) {

        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("world_document_by_id", {worldToken: world.token, worldHelpLinkId: documentId}),
            async: false,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: function (response) {
                if (!skipCheckResult) {
                    if (that.checkisValidResult(response)) {
                       onSuccessFunction(response); 
                    }
                } else {
                    onSuccessFunction(response); 
                }
            }
        });

    }

    // Pedir documentación por carpetas y paginado
    getFolderDocuments(folderId, pageNumber = 0, limit = 20, onSuccessFunction, showModal = true) {

        const that = this;
        const data = {
            page: pageNumber,
            limit: limit,
            internal_links_redirected: true,
        };

        if (folderId) {
            data.folder_id = folderId;
        }

        const token = JSON.parse(decodeURIComponent(storage.getItem('world'))).token;

        $.ajax({
            type: "GET",
            url: Routing.generate("world_documentation_v3_by_folder", { worldToken: token }),
            data: data,
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
                if (typeof (world) === 'undefined') {
                    jqXHR.setRequestHeader("world-token", token);
                }
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    onSuccessFunction(response);
                }
            }
        });

    }

    searchDocumentsInFolder(folderId, term, filters, onSuccessFunction, showModal = true) {

        const that = this;
        const data = {
            folder_id: folderId,
            world_token: world.token,
            searched_text: term,
            is_completed_by_user: filters.is_completed_by_user,
            is_pending_by_user: filters.is_pending_by_user,
            is_fav_to_user: filters.is_fav_to_user,
            is_new_to_user: filters.is_new_to_user,
            has_test: filters.has_test,
            has_question: filters.has_question,
            order_by_rating: filters.order_by_rating,
            is_shared_by_user: filters.is_shared_by_user,
        };

        $.ajax({
            type: "POST",
            url: Routing.generate("world_documentation_search_folder", {worldToken: world.token}),
            data: JSON.stringify(data),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: function (response) {
                if (that.checkisValidResult(response)) {
                    onSuccessFunction(response);
                }
            }
        });

    }

    // IZE-9629: nueva API REST de tracking (sustituye a los sockets de progreso/completitud de documentos).

    getDocumentTrackingStatus(documentId, onSuccessFunction, onErrorFunction, showModal = false) {
        const that = this;

        $.ajax({
            type: "GET",
            url: Routing.generate("api_document_tracking_get", {documentId: documentId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            success: onSuccessFunction,
            error: onErrorFunction
        });
    }

    // Las llamadas de tracking (start/update/stop/completion) antes no tenían manejo de error: si una
    // petición fallaba (red, 5xx, timeout) se perdía en silencio y el contenido quedaba sin registrar
    // ni "en progreso" ni "completado". Se reintentan solo los fallos transitorios (red, 5xx, 408, 429);
    // el resto de 4xx no se repiten. Todas son idempotentes en backend (start comprueba `read`,
    // completion devuelve `was_completed`) y `update` viaja con el tiempo acumulado, así que repetir es seguro.
    _trackingRequest(routeName, documentId, body, onSuccessFunction, showModal, onFailureFunction, attempt = 0) {
        const that = this;
        const retryDelays = [1000, 3000, 6000];

        const settings = {
            type: "POST",
            url: Routing.generate(routeName, {documentId: documentId}),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, showModal);
            },
            // jQuery 1.9 filtra `$.active` si un `success` lanza una excepción (no se decrementa y no
            // salta `ajaxStop`, así que el loader global no se cierra nunca): el callback no debe propagar.
            success: function () {
                try {
                    if (typeof onSuccessFunction === 'function') {
                        onSuccessFunction.apply(this, arguments);
                    }
                } catch (e) {
                    console.error('Tracking callback failed', routeName, documentId, e);

                    if (window.Sentry) {
                        Sentry.captureException(e);
                    }
                }
            },
            error: function (jqXHR) {
                const status = jqXHR ? jqXHR.status : 0;
                const isTransient = status === 0 || status >= 500 || status === 408 || status === 429;

                if (isTransient && attempt < retryDelays.length) {
                    // Se reintenta en segundo plano: que el manejador global (app_v3.js) no muestre el
                    // aviso genérico por cada intento fallido. Si se agotan los reintentos, sí se mostrará.
                    this.skipGlobalErrorAlert = true;

                    setTimeout(function () {
                        that._trackingRequest(routeName, documentId, body, onSuccessFunction, showModal, onFailureFunction, attempt + 1);
                    }, retryDelays[attempt]);

                    return;
                }

                console.error('Tracking request failed', routeName, documentId, status);

                if (window.Sentry) {
                    Sentry.captureMessage('Tracking request failed: ' + routeName + ' doc ' + documentId + ' status ' + status);
                }

                if (typeof onFailureFunction === 'function') {
                    onFailureFunction(jqXHR);
                }
            }
        };

        if (body !== null) {
            settings.data = JSON.stringify(body);
        }

        $.ajax(settings);
    }

    startDocumentTracking(documentId, onSuccessFunction, showModal = false) {
        this._trackingRequest("api_document_tracking_start", documentId, null, onSuccessFunction, showModal);
    }

    updateDocumentTracking(documentId, elapsedTime, onSuccessFunction, showModal = false, onFailureFunction = null) {
        this._trackingRequest("api_document_tracking_update", documentId, {elapsed_time: elapsedTime}, onSuccessFunction, showModal, onFailureFunction);
    }

    stopDocumentTracking(documentId, elapsedTime, onSuccessFunction, showModal = false) {
        this._trackingRequest("api_document_tracking_stop", documentId, {elapsed_time: elapsedTime}, onSuccessFunction, showModal);
    }

    completeDocumentTracking(documentId, onSuccessFunction, showModal = false) {
        this._trackingRequest("api_document_tracking_completion", documentId, null, onSuccessFunction, showModal);
    }

    /**
     * Use for get data from legacy endpoint
     * @param url
     * @param route
     * @param config
     * @param data
     * @param onSuccessFunction
     * @param method
     */
    legacyQueryService(
        {
            route = null,
            config = {},
            data = {},
            onSuccessFunction,
            method = 'POST'
        }) {
        const that = this;
        const dataRequest = {
            world_token: world.token,
            ...data
        }

        // console.log('legacyQueryService....', {route, data, method});

        $.ajax({
            type: method,
            // url: Routing.generate(route, config),
            url: Routing.generate(route, config),
            data: method === 'GET' ? dataRequest : JSON.stringify(dataRequest),
            beforeSend: function (jqXHR, settings) {
                settings.data = that.addAccessToken(settings);
                that.sendHeader(jqXHR, false);
            },
            success: onSuccessFunction
        });
    }

}